/*
  RevoRope — "el cabo" (Home v4 · recorrido en zigzag, revisión 28/07/2026 tarde).

  Motor de trazado del cabo de la Home.

  Qué hace, en orden:
   1. MIDE la página de verdad: alto real de cada sección con anclaje .rr-cabo y,
      entre secciones consecutivas, la BANDA SIN CONTENIDO (del último bloque de
      contenido de una al primero de la siguiente). Nada está horneado a un alto
      de página concreto: al cambiar el viewport se vuelve a medir y a trazar.
   2. TRAZA el recorrido: caída a plomo por el canalón libre de un lado, seno
      tendido que cruza la página entera por una banda sin contenido, caída por
      el canalón del otro lado, y vuelta. Dos cruces en toda la tirada.
   3. DOBLA el cabo en DOS HEBRAS SEPARADAS: muestrea el eje y genera un LAZO
      continuo (hebra de bajada + giro de abajo + hebra de subida). Las hebras se
      desplazan por la NORMAL, no por un translate en X (que estrecharía el par
      justo en los tramos tendidos).
   4. Monta UN SOLO <svg> para toda la tirada, sin viewBox y con width/height en
      px reales -> escala 1:1 siempre, el grosor del trazo nunca se deforma.
   5. Coloca el herraje: cabezal de máquina (de donde sale el cabo), collarín
      sobre el trazado girado con la tangente, y el PASADOR del giro de abajo.
   6. Arrastre: tirar del cabo con el ratón hace scroll. NO toca el scroll nativo
      (rueda, trackpad, teclado, swipe): solo añade una vía más.

  Revisión del 28/07/2026 (tarde), 4 cambios pedidos por Oscar:
   A. Las dos hebras ya NO se tocan: hueco visible de 0.18 x grosor entre ellas
      (ver HEBRA / SEP), con sombreado de oclusión en el flanco interior de cada
      hebra en vez de una línea de valle pintada en el hueco.
   B. Abajo el cabo NO se remata: DA LA VUELTA sobre un pasador. Las dos hebras
      son en realidad las dos piernas de UN MISMO cabo sin fin, unidas por el
      seno que abraza el pasador. Al bajar por la página la trenza corre hacia
      abajo por una pierna y hacia arriba por la otra: el cabo circula.
   C. El cabezal se rehízo con las FOTOS REALES del producto como base.

  Revisión del 14/08/2026: el cabezal ya no se dibuja, ES la máquina. Se cambió
  el SVG hecho a mano (carcasa + tambor + rotor + boca) por un recorte
  fotográfico con alfa del propio giro del hero,
  assets/revorope-cabo-cabezal.webp, en vista de tres cuartos y con las dos
  hebras saliendo por su borde inferior. Consecuencias en el trazado:
   - el cabo ya no nace a plomo: sale con el ángulo real de la foto y se
     endereza con una cúbica ("el asiento"), y es esa deriva la que decide dónde
     se planta la foto, porque quien tiene que acabar en el canalón es el cabo;
   - las hebras nacen algo más abiertas (perspectiva de la foto) y se cierran a
     lo largo del asiento;
   - la foto se pinta la ÚLTIMA, por delante del cabo, así que el arranque del
     trazo queda tapado por la cuerda fotografiada y no hay costura visible.

  Revisión del 17/08/2026 (ESPEJO): la máquina cambia de lado y el cabo con
  ella. Antes vivía en la columna izquierda y el cabo bajaba por el canalón
  izquierdo; ahora vive en la DERECHA y el cabo sale por el costado derecho de
  la máquina y baja por el canalón derecho. El recorrido es el mismo zigzag
  reflejado: plomada derecha -> cruce a la izquierda -> plomada izquierda ->
  vuelta. Tres cosas que conviene saber si se vuelve a tocar:
   - NO se refleja ningún píxel. El cabezal es un recorte de OTRO fotograma del
     mismo giro (el 074 en vez del 020), que es la misma pose vista desde el
     otro lado. Espejar el archivo antiguo habría dejado la escala de
     resistencia y el rótulo REVO ROPE escritos al revés.
   - Sólo cambian de signo tres cosas: la plomada de arranque (xDer), el sentido
     del primer cruce y la tangente de salida de la foto (FOTO.tx).
   - Lo demás es simétrico por construcción y NO se toca: el contenedor está
     centrado, así que el canalón derecho mide exactamente lo que el izquierdo
     (vw - xDer == xIzq), y con eso la holgura de la perspectiva y el tope de la
     línea de agarre valen tal cual.

  Revisión del 15/08/2026 (SEMI-HÉROE): la máquina crece hasta ser la pieza
  protagonista de la sección y baja a la altura del bloque de texto. Dos cambios
  de fondo:
   - dónde va la máquina lo decide la MAQUETACIÓN, no este archivo: la sección
     reserva un hueco vacío ([data-rr-cabo-hueco]) y aquí sólo se encaja dentro.
     Que no pise el texto deja de ser una comprobación y pasa a ser la retícula.
   - el tamaño de la máquina deja de estar atado al grosor del cabo. Antes la
     foto se escalaba para que su cuerda midiera exactamente lo que la dibujada;
     ahora es al revés: la cuerda dibujada NACE midiendo lo que mide el muñón
     fotografiado (a este tamaño, unas 3 veces el grosor de página) y ADELGAZA
     hasta él en la primera caída. Es lo que hace de verdad una cuerda que sale
     hacia el espectador y se aleja, y la unión encaja al 100% a cualquier
     tamaño de máquina. Ver "el tramo de perspectiva" más abajo.
   D. Los giros ya no tienen codo: las transiciones recta->cruce usan smootherstep
      (derivada Y CURVATURA nulas en los dos extremos), así que el cabo sale de la
      vertical sin quiebro. Antes eran dos cúbicas con continuidad solo de
      tangente: la curvatura saltaba de 0 a mucho en un punto y se leía como codo.

  Revisión del 19/08/2026 (MATERIAL): el cabo pasa de COLCHADO a TRENZADO. Sólo
  cambia el material (color, dibujo, sombreado); el recorrido, el arrastre, el
  motor de medición, la máquina y el pasador no se tocan. En corto:
   - el cabo real de la máquina es un cabo TRENZADO en espiga, y se dibujaba como
     un cabo colchado (cápsulas largas a lo largo del eje). Son dos tipos de cabo
     distintos, no un acabado peor. Medido sobre la macro del producto: dos
     familias de picos a +-38 grados del eje, paso 0.244 diámetros, 5 columnas
     por diámetro;
   - el negro no era el correcto: el de la foto es FRÍO (B > R > G en todo el
     rango tonal), el dibujado era gris neutro puro (medido en vivo, B-R +0.3);
   - el trenzado se rasteriza en carriles con dash a lo largo del eje (ver
     pintaTrenza), que es lo que permite que la trenza SIGA CORRIENDO con
     stroke-dashoffset;
   - como eso multiplica las capas, la polilínea se simplifica antes de pintar
     (ver simplifica / TOL_SIMPLIFICA).

  Reglas que respeta:
   - prefers-reduced-motion: el cabo se pinta entero y quieto (sin correr la
     trenza, sin fundido de entrada). El arrastre sigue disponible: lo dirige la
     persona, no una animación.
   - Solo se anima stroke-dashoffset, y la ruta principal es CSS puro
     (scroll-driven animations). El respaldo por scroll agrupa en un rAF.
   - Táctil: la línea de agarre se desactiva por CSS (pointer: fine), así que en
     móvil el cabo es decorativo y no compite con el scroll del dedo.
   - Independiente de rr-nav.js / rr-carousel.js / rr-reveal.js: no los toca.
   - Si no hay ningún .rr-cabo (todas las páginas menos la Home) sale sin
     registrar nada.
*/
(function () {
  'use strict';

  var SVGNS = 'http://www.w3.org/2000/svg';
  var PASO = 8; // muestreo del eje, en px de longitud de arco
  var MIN_BANDA = 70; // una banda por debajo de esto no sirve para cruzar
  var GIRO_PASOS = 26; // muestras del seno que abraza el pasador

  /* VELOCIDAD DE LA TRENZA (19/08/2026): cuántos píxeles avanza el dibujo del
     trenzado por cada píxel de scroll. Antes esto era un número fijo de píxeles
     de scroll por ciclo (45) con una colcha de paso 22px, o sea 0,49. Al pasar a
     trenzado el paso baja a 4-6px, así que un número fijo de scroll por ciclo
     dejaría la trenza reptando; lo que se conserva es la VELOCIDAD LINEAL.
     Se baja de 0,49 a 0,34 a propósito: el dibujo nuevo es mucho más fino y a
     0,49 parpadea al hacer scroll rápido (un patrón de 6px a 1000px/s son 80
     ciclos por segundo). A 0,34 sigue leyéndose que la cuerda corre. */
  var VELOCIDAD_TRENZA = 0.34;
  var scrollPorCiclo = 45; // lo recalcula construye() a partir del paso real

  /* Tolerancia de simplificación del trazado, en px. El cabo trenzado pinta
     muchas más capas que el colchado (una por carril), así que la polilínea se
     simplifica antes de generarlas: los tramos de plomada son rectos y venían
     muestreados cada 8px de arco, o sea centenares de puntos colineales por
     tramo. Con 0.2px la silueta no cambia (por debajo de medio píxel de
     dispositivo incluso a 2x) y el peso del atributo `d` baja un orden de
     magnitud. Ver la comprobación de bytes en DESIGN_SYSTEM.md. */
  var TOL_SIMPLIFICA = 0.2;

  /* Proporciones del cabo, en fracción del grosor TOTAL (--rr-cabo-w).
     HEBRA = diámetro de cada hebra. SEP = distancia de cada hebra al eje.
     El HUECO entre las dos hebras es 2*SEP - HEBRA = 0.18 del grosor, es decir
     un 40% del diámetro de una hebra: se ve el hueco con claridad, pero el par
     sigue leyéndose como UN cabo doblado y no como dos líneas sueltas. */
  var HEBRA = 0.45;
  /* 20/08/2026: SEP sube de 0.315 a 0.36 y MEDIA de 0.58 a 0.63. Encargo de
     Oscar sobre el tramo que baja: "que haya un hueco, no que esten pegadas". El
     hueco es 2*SEP - HEBRA, asi que pasa de 0.18 a 0.27 del grosor: de 4,5 a
     6,75px a 1440 y de 2,7 a 4,05 en movil, o sea de un 40% a un 60% del
     diametro de una hebra. Es lo unico que se ha tocado de las proporciones del
     cabo; el dibujo (patron, angulos, paso, colores, velocidad) no se toca.
     MEDIA sube con ella porque es la media anchura PINTADA del par y es la que
     usa el guardarrail del canalon: si no subiera, el par se acercaria 1px mas
     a la columna de texto de lo que dice el guardarrail. */
  var SEP = 0.36;
  var MEDIA = 0.63; // media anchura pintada del par (incluye sombra) en la tirada normal
  var HOMBRO = 0.42; // radio del hombro del cruce, en fracción del alto de la banda
  var LUZ_X = -0.7071; // luz de estudio desde arriba-izquierda: de ahí sale el
  var LUZ_Y = -0.7071; // brillo especular de cada hebra

  var anclas = [];
  var trozos = []; // trozos del trenzado: { el, y0, y1 } en coordenadas del lienzo
  var arribaLienzo = 0; // pageY del origen del lienzo, para situar los trozos
  var lienzo = null; // { host, svg }
  var medidor = null; // <path> auxiliar para muestrear el eje
  var reduce = false;

  function q(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function crea(nombre, attrs) {
    var n = document.createElementNS(SVGNS, nombre);
    for (var k in attrs) {
      if (Object.prototype.hasOwnProperty.call(attrs, k) && attrs[k] !== null) {
        n.setAttribute(k, attrs[k]);
      }
    }
    return n;
  }

  function numVar(el, prop, porDefecto) {
    var v = parseFloat(getComputedStyle(el).getPropertyValue(prop));
    return isFinite(v) && v > 0 ? v : porDefecto;
  }

  function pinza(v, a, b) {
    return v < a ? a : v > b ? b : v;
  }

  /* Smootherstep: 1ª Y 2ª derivada nulas en los dos extremos. Se usa para la
     apertura progresiva de las hebras al llegar al pasador. */
  function suave(t) {
    return t * t * t * (t * (t * 6 - 15) + 10);
  }

  /* Douglas-Peucker iterativo (sin recursión: la polilínea del lazo pasa de los
     3.000 puntos y una recursión por punto arriesga la pila en móviles viejos).
     Sólo tira puntos que estén a menos de `tol` de la recta que une los que se
     quedan, así que la silueta es la misma a menos de medio píxel. */
  function simplifica(pts, tol) {
    var n = pts.length;
    if (n < 3) return pts.slice();
    var queda = new Uint8Array(n);
    queda[0] = 1;
    queda[n - 1] = 1;
    var pila = [[0, n - 1]];
    var t2 = tol * tol;
    while (pila.length) {
      var seg = pila.pop();
      var a = seg[0];
      var b = seg[1];
      var ax = pts[a].x;
      var ay = pts[a].y;
      var dx = pts[b].x - ax;
      var dy = pts[b].y - ay;
      var ll = dx * dx + dy * dy;
      var peor = -1;
      var dMax = t2;
      for (var i = a + 1; i < b; i++) {
        var px = pts[i].x - ax;
        var py = pts[i].y - ay;
        var d;
        if (ll <= 1e-9) {
          d = px * px + py * py;
        } else {
          var t = (px * dx + py * dy) / ll;
          t = t < 0 ? 0 : t > 1 ? 1 : t;
          var ex = px - t * dx;
          var ey = py - t * dy;
          d = ex * ex + ey * ey;
        }
        if (d > dMax) {
          dMax = d;
          peor = i;
        }
      }
      if (peor >= 0) {
        queda[peor] = 1;
        pila.push([a, peor], [peor, b]);
      }
    }
    var out = [];
    for (var k = 0; k < n; k++) if (queda[k]) out.push(pts[k]);
    return out;
  }

  /* ---------------------------------------------------------------- medición */

  /* MODO (17/08/2026). El breakpoint no se escribe aquí: lo declara el CSS en
     `--rr-cabo-modo` (.rr-cabo, en base.css) y aquí sólo se lee, para que no
     haya dos sitios donde cambiar lo mismo.
      - "recorrido": el zigzag de siempre, que baja por los canalones laterales.
      - "colgante": móvil. Ver trazar(). */
  function modo() {
    var v = getComputedStyle(anclas[0].el).getPropertyValue('--rr-cabo-modo') || '';
    return v.indexOf('colgante') >= 0 ? 'colgante' : 'recorrido';
  }

  /* DÓNDE SE PLANTA LA MÁQUINA (25/08/2026). Igual que modo(): el breakpoint no
     se escribe aquí, lo declara `--rr-cabo-maquina` en base.css. "centrada"
     apaga el CORRIMIENTO, porque en el apilado de móvil el hueco ya viene
     centrado por la maquetación y correrla encima la sacaría del centro. */
  function maquinaCentrada() {
    var v = getComputedStyle(anclas[0].el).getPropertyValue('--rr-cabo-maquina') || '';
    return v.indexOf('centrada') >= 0;
  }

  function medir() {
    var scroll = window.pageYOffset || document.documentElement.scrollTop || 0;

    var tramos = anclas.map(function (a) {
      var sec = a.el.closest('.rr-section') || a.el.parentElement;
      var r = sec.getBoundingClientRect();
      var cont = q('.rr-container', sec);
      var hijos = cont
        ? Array.prototype.filter.call(cont.children, function (k) {
            var kr = k.getBoundingClientRect();
            return kr.height > 4 && kr.width > 4;
          })
        : [];
      var arriba = r.top + scroll;
      var abajo = arriba + r.height;
      return {
        ancla: a,
        arriba: arriba,
        abajo: abajo,
        contArriba: hijos.length ? hijos[0].getBoundingClientRect().top + scroll : arriba,
        contAbajo: hijos.length
          ? hijos[hijos.length - 1].getBoundingClientRect().bottom + scroll
          : abajo
      };
    });

    var cont = q('.rr-section .rr-container');
    var cr = cont ? cont.getBoundingClientRect() : { left: 0 };
    var pad = cont ? parseFloat(getComputedStyle(cont).paddingLeft) || 0 : 20;
    var vw = document.documentElement.clientWidth;
    var grosor = numVar(anclas[0].el, '--rr-cabo-w', 10);

    // Canalón libre: del borde de la ventana al primer píxel de texto. El cabo
    // NO se planta en su mitad: se planta al 70% (o sea, escorado hacia la
    // columna de contenido) y nunca a más de 40px de ella.
    // 20/08/2026: el tope baja de 84 a 60px. El 70% se queda como estaba, y NO
    // por conservadurismo: se probó subirlo (0,74 y 0,86) para llevar la máquina
    // más a la izquierda, como se pidió, y el barrido de choques cabo<->texto lo
    // tumbó. A 1280 el escalón es un acantilado: con 61,6px de plomada hay 3
    // muestras de roce y con 65,1 (o sea 3,5px más) hay 81, porque la cuerda se
    // sube encima del <h2> "Dos máquinas, un mismo estándar". El guardarraíl
    // `canal - media - 3` no lo ve: mide contra el borde del .rr-container, y
    // hay secciones cuyo texto sangra por fuera de él. Así que a 1280 no queda
    // margen, y a 1440 el término que manda es justo ese 70%.
    // Quien sí mueve la máquina a 1440 es el TOPE, que baja de 84 a 40px: por
    // encima de ~1330px de ventana pasa a ser el término que manda, y ahí el
    // canalón es ancho de sobra. Medido: xIzq 117,6 -> 128 a 1440, 324 -> 368 a
    // 1920 y 644 -> 688 a 2560, con 0 choques en los tres. El acantilado de
    // 1440 está en 144,5 (10 muestras de roce), así que 128 deja 16px de
    // margen; se eligió eso y no apurar, porque el contenido de la página puede
    // moverse y el roce con texto es la regla dura de esta pieza.
    // 17/08/2026: eran 50% y 110px. Encargo de Oscar, repetido dos veces sobre
    // el resultado en vivo: la máquina de "cómo funciona" "más a la izquierda,
    // más cerca del texto". Bajar el sangrado de la maquetación (el
    // margin-inline-end de .rr-como__head) NO bastaba, y el motivo es del motor:
    // la máquina no se planta donde dice la retícula, se planta donde tiene que
    // estar para que SU CUERDA caiga en la plomada (ver maquinaEnHueco), y esa
    // deriva está topada por la caída disponible antes del contenido de abajo.
    // Medido a 1440: la maquetación pedía la máquina 66px a la izquierda y el
    // motor sólo podía darle 44. Así que quien manda es la plomada, y es la
    // plomada la que se mueve. Efecto medido: −34px a 1440, −26px a 1920/2560,
    // −18px a 1280, y nada por debajo de 1024 (ahí manda ya el tercer término).
    // El guardarraíl es el mismo de siempre y no se toca: `canal - media - 3`
    // deja SIEMPRE 3px entre lo pintado y la columna de texto.
    var canal = cr.left + pad;
    var media = grosor * MEDIA + 2;
    var xIzq = Math.max(media, canal - 40, Math.min(canal * 0.7, canal - media - 3));

    /* En modo colgante la plomada es el EJE DE LA PÁGINA. Poniendo xIzq en la
       mitad, xDer (que se define como vw - xIzq) sale la misma mitad, así que
       todo lo que abajo habla de "el canalón de arranque" apunta ya al centro
       sin ninguna rama extra. */
    var colgante = modo() === 'colgante';
    if (colgante) xIzq = vw / 2;

    return {
      tramos: tramos,
      vw: vw,
      canal: canal,
      grosor: grosor,
      colgante: colgante,
      centrada: maquinaCentrada(),
      xIzq: xIzq,
      xDer: vw - xIzq,
      arriba: tramos[0].arriba,
      alto: tramos[tramos.length - 1].abajo - tramos[0].arriba
    };
  }

  /* ----------------------------------------------------------------- trazado */

  /* Bandas sin contenido entre dos secciones: por ahí es por donde cruza el
     cabo de un canalón al otro.

     GUARDARRAÍL VERTICAL (25/08/2026). Cada banda se estrecha por sus dos
     extremos antes de ofrecerla. Es exactamente el mismo criterio que el
     guardarraíl horizontal de la plomada (`canal - media - 3` en medir()),
     aplicado al otro eje, y faltaba: la banda iba de `contAbajo` a `contArriba`,
     o sea DE BORDE A BORDE del contenido, así que el TRAZO del cabo (que tiene
     grosor) mordía la primera línea de texto de la sección siguiente aunque su
     eje se quedara justo en el límite.

     Se descubrió midiendo: al crecer la sección "Cómo funciona" con la cinta
     nueva, el cruce de 1024px pasó a caer contra el <h2> "Dos máquinas, un
     mismo estándar", con la capa de sombra penetrando 0,98px en su primera caja
     de línea (antes despejaba por 3,63px). No era culpa de la cinta: la cinta
     sólo movió el reparto, el hueco de guarda no existía y cualquier cambio de
     alturas podía destaparlo. De ahí que se arregle en la banda y no moviendo
     la cinta.

     El margen es el semiancho REAL de lo que se pinta (la capa de sombra mide
     0,504 x el grosor del cabo, así que su semiancho es 0,252 x grosor) más los
     mismos 3px de guarda que usa la plomada. */
  var SOMBRA_SEMI = 0.252;

  function bandasLibres(g) {
    var guarda = g.grosor * SOMBRA_SEMI + 3;
    var out = [];
    for (var i = 0; i < g.tramos.length - 1; i++) {
      var a = g.tramos[i].contAbajo - g.arriba + guarda;
      var b = g.tramos[i + 1].contArriba - g.arriba - guarda;
      if (b <= a) continue;
      out.push({ i: i, a: a, b: b });
    }
    return out;
  }

  function eligeCruces(g) {
    var bandas = bandasLibres(g).filter(function (b) {
      return b.b - b.a >= MIN_BANDA;
    });
    if (!bandas.length) return [];

    function masCerca(objetivo, usadas) {
      var mejor = null;
      var dist = Infinity;
      bandas.forEach(function (b) {
        if (usadas.indexOf(b.i) >= 0) return;
        var d = Math.abs((b.a + b.b) / 2 - objetivo);
        if (d < dist) {
          dist = d;
          mejor = b;
        }
      });
      return mejor;
    }

    var usadas = [];
    var c1 = masCerca(g.alto * 0.34, usadas);
    if (c1) usadas.push(c1.i);
    var c2 = masCerca(g.alto * 0.7, usadas);
    if (c2) usadas.push(c2.i);

    return [c1, c2].filter(Boolean).sort(function (a, b) {
      return a.a - b.a;
    });
  }

  /* Cabezal de máquina — la MÁQUINA REAL (14/08/2026; agrandada a SEMI-HÉROE el
     15/08/2026).
     Sustituye al cabezal dibujado a mano (carcasa + tambor + rotor + boca en
     SVG). Es un recorte fotográfico con alfa del propio giro del hero,
     assets/revorope-cabo-cabezal.webp: vista de tres cuartos, con el rotor rojo
     y las patas del soporte. Apunta hacia un lado, no de frente hacia abajo, que
     es lo que se pidió.

     ARCHIVO ESPEJO (17/08/2026): 476x579, recortado del fotograma 074 en vez
     del 020. El giro cubre ~180 grados en 90 fotogramas, así que el 074 (~148)
     es la MISMA pose vista desde el otro lado: el brazo de anclaje queda a la
     izquierda, el tambor a la derecha y la cuerda sale por el costado DERECHO de
     la máquina. Es geometría real, no una imagen reflejada: espejar el archivo
     antiguo habría dejado la escala de resistencia (50 · 75 · 100 · 125 · 150 ·
     175) y el rótulo REVO ROPE escritos al revés. Contrapartida asumida: en esa
     cara no se ve el rotor rojo, pero la cara del rótulo es bastante más clara
     (luminancia media medida 67 frente a 54) y se lee mejor sobre negro.

     Sigue SIN NADA DE CUERDA FOTOGRAFIADA, como el archivo del 16/08/2026: si
     conviven la cuerda de la foto y la dibujada se leen como dos objetos
     distintos. Aquí se borró ajustando la pestaña exterior del tambor a una
     elipse (contorno medido en las filas limpias) y repintando la garganta como
     garganta vacía; el script está en media-pendiente/_cabo/. Así sólo existe
     UNA cuerda en la página: ésta, la dibujada, que nace DENTRO de la máquina y
     asoma por el filo inferior DERECHO.

     Todo lo de abajo son coordenadas MEDIDAS sobre el archivo, guardadas como
     FRACCIONES (del ancho, salvo la fila de salida, que es del alto) para que
     escalen solas. Son el contrato que hace que la cuerda nazca por donde toca;
     si se cambia la foto hay que volver a medirlas. Comprobado con la tangente
     de abajo: el par asoma por el filo del tambor en (0.791, 0.796). */
  var FOTO = {
    w: 476,
    h: 579,
    axF: 0.7689, // eje del par (x = 535 del fotograma original, recorte en 169)
    ayF: 0.7427, // fila de la boca, en fracción del ALTO (y = 468, recorte en 38)
    sepF: 0.0525, // media separación entre hebras (centros medidos en 514 y 564)
    hebraF: 0.0588, // grosor de UNA hebra (~28 px sobre 476 de ancho)
    /* Tangente de salida del eje: baja hacia abajo-DERECHA, 19 grados de la
       vertical (71 de la horizontal), que es la caída natural de la cuerda al
       dejar la garganta del tambor por ese costado. */
    tx: 0.327,
    ty: 0.945,
    /* El trazo ataca DENTRO de la foto (0.03 del ancho por encima de la boca) y
       la foto se pinta la ÚLTIMA, por delante del cabo: así el arranque queda
       tapado por la propia máquina y no hay junta a la vista. */
    leadF: 0.03,

    /* SALIDA CURVA POR EL FLANCO (20/08/2026). Encargo de Oscar sobre dos
       capturas anotadas: las dos hebras dejan de caer a plomo nada mas salir y
       pasan a SALIR CURVANDO HACIA LA DERECHA desde el flanco del tambor, para
       bajar despues por el canalon derecho.

       Oscar marco con flechas donde tiene que salir cada hebra, en fraccion de
       la caja de la foto: superior (0.78, 0.28) e inferior (0.81, 0.57). Las
       DOS x caen sobre la CARA del tambor, no en su filo: medido sobre el canal
       alfa del archivo, el borde derecho de la silueta esta en 0.962 en la fila
       0.28 y en 0.985 en la fila 0.57. Arrancar el trazo ahi seria pintar la
       cuerda ENCIMA del metal, que es justo el fallo que habia que evitar (lee
       como pegatina). Asi que se toma su ALTURA, que es lo que describe el
       encargo, y la x sale del alfa real: el trazo arranca DENTRO de la silueta
       y asoma solo, por detras del filo.

       Perfil del borde derecho, medido (ultima columna opaca por fila):

         y/alto  0.20   0.24   0.28   0.32   0.42   0.48   0.57   0.62   0.70
         x/ancho 0.914  0.941  0.962  0.977  0.998  0.998  0.985  0.969  0.924

       El mecanismo: el eje sale HORIZONTAL, y la normal de un eje horizontal es
       VERTICAL, asi que el desplazamiento perpendicular de las dos hebras (el
       mismo de siempre) ya las separa EN ALTURA. El escalon no hay que
       fabricarlo con desvios laterales como en colgante: sale del giro. Cuando
       el eje termina de girar y baja a plomo, esa misma normal vuelve a ser
       horizontal y el par queda otra vez de lado. Por eso la hebra que sale por
       ARRIBA es la que acaba por FUERA. */
    salXF: 0.795, // x del eje: la media de las dos salidas de Oscar (0.78 y 0.81)
    salYF: 0.425, // altura del eje: la media de las dos salidas de Oscar
    /* El escalon entre las dos salidas (0.29 del alto: las dos flechas de
       Oscar, 0.57 - 0.28) ya no se declara como numero suelto. Vive donde tiene
       que vivir, en la diferencia de las dos bocas de aqui abajo, que es lo que
       de verdad se pinta. */

    /* LAS DOS BOCAS, DECLARADAS (22/08/2026). Hasta hoy los dos puntos de
       nacimiento no se escribian: se DEDUCIAN desplazando el eje por su normal
       una distancia `sepNace` (media del paso, 0.145 del alto). Como la normal
       depende de la tangente del eje, eso ataba la posicion de las bocas al
       angulo con el que sale la cuerda, y por eso la tangente tenia que ser casi
       horizontal (4,9 grados HACIA ARRIBA): era el unico angulo que dejaba las
       dos bocas donde Oscar las marco.

       Ese amarre es el que se rompe hoy, porque tenia dos consecuencias malas
       (las dos medidas en vivo antes de tocar nada, ver DESIGN_SYSTEM.md):
        - la cuerda salia HACIA EL LADO y luego tenia que girar ~93 grados para
          caer, o sea un codo, no una caida;
        - para separar las bocas 0.29 del alto por la normal hacia falta un
          desplazamiento enorme (51px a 1440, 36px a 1024) sobre una curva cuyo
          radio en el codo era mucho menor (4,1px medidos a 1024): desplazar una
          curva mas de su radio de curvatura la hace CUSPIDE y las dos hebras se
          barren la una sobre la otra. Eso es lo que Oscar vio como "se mete y se
          junta con la otra de manera muy rara".

       Asi que las bocas pasan a ser dato, no consecuencia: se declaran aqui, en
       fraccion del ancho (x) y del alto (y) de la foto, con los MISMOS valores
       que renderizaba la version anterior, o sea las dos flechas de Oscar del
       20/08 (superior 0.78/0.28, inferior 0.81/0.57). No se mueven ni un pixel;
       lo que cambia es que ahora el eje es libre de salir cayendo. */
    bocaSupXF: 0.784,
    bocaSupYF: 0.280,
    bocaInfXF: 0.806,
    bocaInfYF: 0.570
  };

  /* ANGULO DE SALIDA DEL EJE (22/08/2026). Encargo de Oscar sobre el resultado
     en vivo: "que la cuerda siga mas como sale [en] la imagen [...] y que el
     giro que hace la cuerda al salir de la maquina, justo cuando baja, que sea
     mas natural".

     Referencia medida, no a ojo: el cabo REAL fotografiado del hero
     (assets/revorope-giro-082.webp, el fotograma de reposo) deja el tambor
     CAYENDO. Trazadas las dos hebras por filas de alfa, sus centros bajan a 34
     grados de la vertical justo al salir y se van abriendo hasta ~60 grados al
     alejarse. O sea: sale hacia abajo y se tumba, nunca al reves.

     El eje dibujado no puede copiar ese angulo tal cual (tiene que llegar al
     canalon, que esta a la derecha), pero si puede respetar la regla: SALIR POR
     DEBAJO DE LA HORIZONTAL y enderezarse. El angulo se deriva de la CUERDA
     geometrica (la recta del punto de salida a la plomada), no se hornea:

       th = cuerda * SALIDA_K, topado en [SALIDA_MIN, SALIDA_MAX]

     y ademas se obliga a quedar SALIDA_HOLGURA por debajo de la cuerda, porque
     si la tangente de salida coincide con la cuerda la curva degenera en una
     recta diagonal, que es el "puntal a 45 grados" ya descartado el 28/07. */
  var SALIDA_K = 0.66;
  var SALIDA_MIN = (30 * Math.PI) / 180;
  var SALIDA_MAX = (58 * Math.PI) / 180;
  var SALIDA_HOLGURA = (8 * Math.PI) / 180;

  /* Cuanta longitud de arco hace falta, como MULTIPLO del desvio de nacimiento,
     para que ese desvio se cierre sin que ninguna hebra tenga que remontar. Con
     smootherstep la derivada maxima vale 1,875/L, asi que con 4,2 el desvio
     aporta como mucho 0,45 de componente frente a la tangente del eje: la hebra
     de abajo se tumba mientras se acerca, pero nunca sube. */
  var NACE_K = 4.2;

  /* Cuanto mas arco tiene la hebra de ABAJO para cerrar su desvio de nacimiento,
     comparada con la de arriba. Ver el bloque "CIERRE ASIMETRICO" en construye()
     para el porque: con el eje bajando, las dos no hacen el mismo trabajo. El
     valor se eligio midiendo, no a ojo (barrido 1.0 / 1.6 / 2.2 / 2.8 / 3.4). */
  var NACE_INF = 2.2;

  /* Cuanto se corre la maquina a la izquierda, en fraccion del ANCHO DE VENTANA.
     Es la cifra literal del recuadro verde que dibujo Oscar (~78px a 1440). Solo
     se aplica en modo recorrido: en colgante la maquina va centrada a proposito.
     Ojo al leer el resultado: el movimiento REAL es algo mayor que este numero,
     porque ademas la maquina deja de estar clavada sobre la plomada (ver
     maquinaEnHueco) y eso por si solo ya la suelta unos 24px a 1440. Se topa por
     la izquierda con la columna de texto y por la caida que necesita el giro. */
  var CORRIMIENTO = 0.054;

  /* DERIVA: cuánto se corre el cabo de lado por cada píxel que baja mientras se
     endereza. No es un número de gusto: es la tangente del ángulo con el que la
     cuerda sale de la foto (19 grados de la vertical), así que el asiento es
     exactamente la caída que hace falta para pasar de ese ángulo a la plomada
     del canalón sin forzar la curva. */
  var DERIVA = 0.34;

  /* Cuanta CAIDA hace falta por cada pixel de viaje horizontal en el cuarto de
     giro de la salida curva. Con 1.45 el giro se lee como una cuerda que se
     tumba y se endereza; por debajo de ~1.1 sale un codo y por encima de ~2 la
     curva se estira tanto que ya no se ve girar. */
  var RATIO_GIRO = 1.45;

  /* PERSPECTIVA: la cuerda dibujada nace midiendo lo que mediría la cuerda REAL
     de esa máquina a ese tamaño (hebraF del ancho de la foto: con la máquina a
     tamaño de semi-héroe, unas 2,3 veces el grosor normal del cabo desde el
     ajuste del 16/08) y ADELGAZA hasta el grosor de página a lo largo de una
     caída de PERSP x el alto de la máquina. No es un truco para tapar un
     desajuste: es lo que hace de verdad una cuerda que sale hacia el especta-
     dor y se aleja. Y libera el tamaño de la máquina, que hasta hoy estaba
     atado al grosor del cabo. */
  var PERSP = 0.85;

  /* PERSPECTIVA APAGADA (16/08/2026). Encargo de Oscar: "la cuerda un pelín más
     grande en toda la página, que sea igual en todas las posiciones". El cabo
     pasa a tener UNA SOLA GALGA de punta a punta: ya no nace con el grosor de la
     cuerda real de la máquina para adelgazar al alejarse. Se puede porque desde
     el mismo día la foto no tiene NINGUNA cuerda con la que comparar el empalme
     (era eso lo que obligaba a nacer gordo), y el arranque queda tapado por la
     propia máquina. Toda la maquinaria de perspectiva se deja intacta y sólo se
     neutraliza aquí: para recuperarla basta poner esto en true. */
  var PERSPECTIVA = false;

  /* El hueco que la maquetación le reserva a la máquina ([data-rr-cabo-hueco]).
     La sección declara DÓNDE cabe; aquí sólo se encaja dentro. */
  function rectHueco(g) {
    var el = document.querySelector('[data-rr-cabo-hueco]');
    if (!el) return null;
    var r = el.getBoundingClientRect();
    if (!(r.width > 60 && r.height > 60)) return null;
    var scroll = window.pageYOffset || document.documentElement.scrollTop || 0;
    return { el: el, x: r.left, y: r.top + scroll - g.arriba, w: r.width, h: r.height };
  }

  /* Primer contenido que empieza POR DEBAJO del hueco. El asiento tiene que
     estar hecho antes de llegar ahí: a partir de ese punto la columna de
     contenido vuelve a ocupar el ancho entero y el cabo ya no puede andar por en
     medio. Se miran los hermanos del hueco (el texto, en el apilado de móvil) y
     los hijos del contenedor (los puntos, en el semi-héroe de escritorio). */
  function techoDeAbajo(g, hu) {
    var scroll = window.pageYOffset || document.documentElement.scrollTop || 0;
    var cont = hu.el.closest('.rr-container');
    var cajas = [];
    if (hu.el.parentElement) {
      cajas = cajas.concat(Array.prototype.slice.call(hu.el.parentElement.children));
    }
    if (cont) cajas = cajas.concat(Array.prototype.slice.call(cont.children));
    var suelo = hu.y + hu.h - 24;
    var mejor = Infinity;
    cajas.forEach(function (n) {
      if (n === hu.el || n.contains(hu.el)) return;
      var r = n.getBoundingClientRect();
      if (r.height < 4) return;
      var top = r.top + scroll - g.arriba;
      if (top >= suelo && top < mejor) mejor = top;
    });
    return isFinite(mejor) ? mejor : g.tramos[0].contAbajo - g.arriba + 40;
  }

  /* Primer contenido que comparte FRANJA VERTICAL con el hueco, o sea la
     columna de texto en el semi-heroe de escritorio. Es el tope por la izquierda
     cuando la maquina se corre (ver CORRIMIENTO). En el apilado de movil/tablet
     el texto va DEBAJO, no al lado, asi que no hay pared y la maquina puede
     correrse entera. */
  function paredIzquierda(g, hu) {
    var scroll = window.pageYOffset || document.documentElement.scrollTop || 0;
    var pared = 0;
    if (!hu.el.parentElement) return pared;
    Array.prototype.slice.call(hu.el.parentElement.children).forEach(function (n) {
      if (n === hu.el || n.contains(hu.el)) return;
      var r = n.getBoundingClientRect();
      if (r.height < 4 || r.width < 4) return;
      var top = r.top + scroll - g.arriba;
      var bot = r.bottom + scroll - g.arriba;
      if (bot <= hu.y + 8 || top >= hu.y + hu.h - 8) return;
      if (r.right > pared) pared = r.right;
    });
    return pared;
  }

  function armaMaquina(x, y, w, h, deriva, espacio, giro) {
    return {
      w: w,
      h: h,
      x: x,
      y: y,
      ax: x + FOTO.axF * w,
      ay: y + FOTO.ayF * h,
      lead: FOTO.leadF * w,
      asiento: Math.max(Math.abs(deriva) / DERIVA, w * 0.3),
      /* Caida del cuarto de giro de la salida curva (modo recorrido): depende
         del viaje horizontal hasta la plomada y de la caida disponible antes del
         contenido de debajo. La calcula maquinaEnHueco. */
      giro: giro || 0,
      /* Salida curva: punto de arranque del EJE. Las dos bocas por las que
         asoma cada hebra ya no se derivan de aqui: van declaradas en
         FOTO (bocaSupXF/YF y bocaInfXF/YF) y las monta trazar(). */
      salX: x + FOTO.salXF * w,
      salY: y + FOTO.salYF * h,
      // Caída disponible desde la boca hasta el primer contenido de debajo.
      espacio: espacio,
      sepIni: FOTO.sepF * w,
      hebraFoto: FOTO.hebraF * w
    };
  }

  /* NACIMIENTO ESCALONADO (17/08/2026, reescalado el 20/08/2026). Encargo de
     Oscar: "las dos hebras tienen que salir a alturas distintas, la de arriba
     mas por arriba, como en la foto real". Hasta el 17/08 las dos nacian a la
     MISMA altura, y no era casualidad: se dibujan como dos desplazamientos
     simetricos del mismo eje, asi que su punto de aparicion solo depende de
     donde acaba el alfa de la foto, y a esa altura el borde de la maquina es
     casi horizontal.

     No se arregla desplazando una hebra a lo largo del eje: ese desplazamiento
     es una traslacion SOBRE SU PROPIA RECTA, asi que la hebra sale exactamente
     por el mismo pixel (comprobado antes de escribir nada). Lo que decide la
     altura de salida es la posicion LATERAL, porque el filo inferior de la foto
     sube hacia la derecha. Medido sobre el canal alfa de
     assets/revorope-cabo-cabezal.webp (476x579), ultima fila opaca por columna:

       x/ancho  0.740  0.769  0.800  0.815  0.862  0.900  0.920  0.930  0.940
       y/alto   0.805  0.801  0.794  0.791  0.762  0.729  0.706  0.693  0.679

     20/08/2026, sobre el resultado en vivo: "donde sale de la maquina estan muy
     juntas, tienen que estar separadas desde el primer momento" y "la superior
     tiene que subir bastante mas, y la de abajo un pelin tambien". Asi que cada
     hebra pasa a tener SU PROPIA columna de nacimiento y las dos suben:

      - la de FUERA, de 0.862 a 0.930: 0.069 del alto mas arriba (0.762 -> 0.693
        en la tabla). Sale ya por el flanco del tambor, no por su filo inferior.
      - la de DENTRO deja de ser "el eje menos sep0" (0.743, el filo plano, que
        es donde el borde de la foto esta mas horizontal y por eso las dos salian
        casi a la misma altura) y pasa a columna propia, 0.805: sube 0.011 del
        alto (0.805 -> 0.794 en la tabla). Ese es el "pelin". Se probo 0.815 y se
        bajo a 0.805 porque, a igualdad de escalon, cada punto que sube la hebra
        de dentro se lo quita a la separacion lateral del par al nacer, que es la
        otra mitad del encargo.

     Con eso el escalon entre los dos nacimientos se multiplica y el par nace mas
     abierto de lo que llega a estar despues, que era la queja: la separacion ya
     existe en el primer pixel y desde ahi solo se cierra al asentarse. La
     separacion de REGIMEN la siguen fijando HEBRA/SEP y no se toca.

     Ojo: la de dentro queda a la DERECHA del eje al nacer (0.805 > axF 0.7689),
     o sea que su separacion arranca en negativo. Es legitimo (offset() acepta el
     signo) y solo significa que durante el asiento el eje del par no pasa entre
     las dos hebras. El eje no se pinta.

     Es geometria del propio archivo: si se cambia la foto, hay que volver a
     medir esta tabla igual que las coordenadas de FOTO. */
  var NACE_CENTRO = 0.93;
  var NACE_CENTRO_INT = 0.805;

  /* Flanco exterior de la hebra de fuera, en fracción del ancho de la foto: es
     lo que no se puede salir de la ventana cuando la máquina sangra por el filo.
     Con el archivo espejo la hebra de fuera es la de la DERECHA, y desde el
     escalón de arriba su punto más ancho es el de nacimiento, no el del par ya
     asentado. */
  var FLANCO = NACE_CENTRO + FOTO.hebraF / 2;

  /* Encaja la máquina en su hueco y decide de paso la longitud del asiento.
     Orden de preferencia, que es lo que hace que esto funcione en todos los
     anchos sin ninguna coordenada horneada:
      1. La foto se queda pegada a la DERECHA de su hueco (donde la puso la
         maquetación) y el cabo deriva hasta la plomada del canalón derecho. La
         deriva cabe si hay caída suficiente antes del primer contenido de debajo.
      2. Si no cabe, la foto se corre hacia la derecha (puede sangrar por el filo
         de la ventana, como la máquina del hero) para acortar la deriva.
      3. Si ni así, se encoge.
     El tope de sangrado es que la hebra derecha entera siga dentro de la
     ventana. */
  function maquinaEnHueco(g, hu) {
    var limite = techoDeAbajo(g, hu);
    var pared = paredIzquierda(g, hu);
    var base = Math.min(hu.w, (hu.h * FOTO.w) / FOTO.h);
    var respaldo = null;

    for (var k = 1; k >= 0.5; k -= 0.05) {
      var w = base * k;
      var h = (w * FOTO.h) / FOTO.w;
      var y = hu.y + (hu.h - h) / 2;

      if (g.colgante) {
        /* MODO COLGANTE (movil): INTACTO. Sigue saliendo por la boca de abajo y
           cayendo a plomo sobre el eje de la pagina, tal como se aprobo el
           17/08. La salida curva es una pieza de escritorio: existe para que la
           cuerda vaya a buscar el canalon lateral, y en movil no hay canalon que
           buscar (el cabo baja por el centro de la pagina). */
        var ayC = y + FOTO.ayF * h;
        var espC = Math.max(70, limite - ayC - 12);
        var dMaxC = espC * DERIVA;
        var dC = pinza(hu.x + hu.w - w + FOTO.axF * w - g.xDer, -dMaxC, dMaxC);
        var mC = armaMaquina(g.xDer + dC - FOTO.axF * w, y, w, h, dC, espC, 0);
        if (!respaldo) respaldo = mC;
        if (mC.x + w * FLANCO <= g.vw - 2 && mC.x >= -w * 0.06) return mC;
        continue;
      }

      /* MODO RECORRIDO (20/08/2026). La maquina YA NO se planta donde tiene que
         estar para que su cuerda caiga en la plomada: se planta donde la pide la
         composicion, y es la CUERDA la que va a buscar el canalon con el cuarto
         de giro de salida(). Ese es el cambio que desbloquea moverla a la
         izquierda; el 19/08 se quedo a medias justo porque el guardarrail de la
         plomada topaba a 1280.

         Orden de preferencia:
          1. apoyada a la derecha de su hueco y corrida CORRIMIENTO x su ancho a
             la izquierda, que es lo que dibujo Oscar;
          2. si con eso invade la columna de texto o el giro no cabe en la caida
             disponible, se corre menos (nunca a la derecha de su hueco);
          3. si aun asi no cabe en el hueco, se encoge (el bucle de k).

         25/08/2026 — MAQUINA CENTRADA (movil). Con `--rr-cabo-maquina:
         centrada` el corrimiento se apaga y la maquina se queda EXACTAMENTE
         donde la deja el hueco. No es un caso especial del motor: el hueco ya
         viene centrado por la maquetacion (justify-self: center en home.css) y
         el corrimiento, pensado para escorarla dentro de una columna, la
         sacaria 21px a la izquierda del centro a 390px. La caida que necesita
         el giro para llegar al canalon desde el centro la da el row-gap de
         `.rr-como__head`, tambien en home.css. */
      var ay = y + FOTO.salYF * h;
      var espacio = Math.max(70, limite - ay - 12);
      var x0 = hu.x + hu.w - w;
      var xPared = pared > 0 ? pared + 24 : 0;
      // Tope por el giro: el cuarto de vuelta necesita caida proporcional al
      // viaje horizontal, y la caida disponible es `espacio`.
      var viajeMax = Math.max(0, (espacio - 24) / RATIO_GIRO);
      var xGiro = g.xDer - viajeMax - FOTO.salXF * w;
      var corrimiento = g.centrada ? 0 : CORRIMIENTO * g.vw;
      var x = Math.max(xPared, xGiro, x0 - corrimiento);
      x = Math.min(x, x0);
      if (x + w > g.vw - 2) x = g.vw - 2 - w;

      var viaje = g.xDer - (x + FOTO.salXF * w);
      var giro = pinza(
        Math.max(h * 0.62, Math.abs(viaje) * RATIO_GIRO),
        Math.min(90, espacio),
        espacio
      );
      var m = armaMaquina(x, y, w, h, 0, espacio, giro);
      if (!respaldo) respaldo = m;
      if (x >= xPared - 0.5 && x + w <= g.vw - 2) return m;
    }
    return respaldo;
  }

  function cabezal(g) {
    var hu = rectHueco(g);
    if (!hu) {
      /* Respaldo si la sección no declara hueco (mirrors viejos, o la sección
         reutilizada en otra plantilla): se usa el aire que haya sobre el primer
         bloque de contenido, que es como se colocaba antes del 15/08/2026. */
      var aire = Math.max(120, g.tramos[0].contArriba - g.tramos[0].arriba);
      var ancho = Math.min(g.vw * 0.42, 300);
      hu = {
        el: g.tramos[0].ancla.el,
        x: Math.max(0, g.vw - ancho),
        y: 4,
        w: ancho,
        h: aire - 8
      };
    }
    return maquinaEnHueco(g, hu);
  }

  /* Muestrea la cúbica del asiento: sale de la boca con la tangente real de la
     foto y llega a la plomada con tangente vertical. Continuidad de tangente en
     los dos extremos, así que no hay quiebro ni al salir de la foto ni al entrar
     en la caída recta. Arranca `lead` px por encima del corte de los muñones,
     dentro de la foto, para que la junta quede tapada. */
  function asienta(pts, maq, xPlomada) {
    var L = Math.max(24, maq.asiento / 2);
    var p0 = { x: maq.ax - FOTO.tx * maq.lead, y: maq.ay - FOTO.ty * maq.lead };
    var p1 = { x: p0.x + FOTO.tx * L, y: p0.y + FOTO.ty * L };
    var p3 = { x: xPlomada, y: maq.ay + maq.asiento };
    var p2 = { x: xPlomada, y: p3.y - L };
    var n = pinza(Math.round(maq.asiento / 6), 12, 44);
    for (var i = 0; i <= n; i++) {
      var t = i / n;
      var u = 1 - t;
      pts.push({
        x: u * u * u * p0.x + 3 * u * u * t * p1.x + 3 * u * t * t * p2.x + t * t * t * p3.x,
        y: u * u * u * p0.y + 3 * u * u * t * p1.y + 3 * u * t * t * p2.y + t * t * t * p3.y
      });
    }
  }

  /* SALIDA CURVA (20/08/2026, reescrita el 22/08/2026 · modo recorrido). El eje
     sale del flanco del tambor y llega a la plomada con tangente vertical, sin
     quiebro en ninguno de los dos extremos.

     No es decoracion. Mientras el cabo caia a plomo nada mas salir, la maquina
     tenia que estar exactamente encima del canalon, asi que su posicion era una
     consecuencia de la plomada y no una decision de composicion. Con el giro, la
     cuerda va a buscar el canalon por su cuenta y la maquina queda libre.

     LO QUE CAMBIA EL 22/08: la tangente de salida. Hasta hoy era casi
     HORIZONTAL (4,9 grados hacia arriba), y no por gusto: era el unico angulo
     que dejaba las dos bocas donde Oscar las marco, porque las hebras se
     separaban por la NORMAL del eje. Desde que las bocas van declaradas (ver
     FOTO) ese amarre no existe, asi que el eje puede hacer lo que hace la
     cuerda de la foto: SALIR CAYENDO. El angulo lo fija SALIDA_K contra la
     cuerda geometrica hasta la plomada, y los brazos de control se calculan
     para que el poligono sea monotono en x y en y, que es lo que garantiza que
     no haya ni codo ni rebote en ningun ancho. */
  function salida(pts, maq, xPlomada) {
    /* Sin `lead`: el trazado arranca EXACTAMENTE en el punto de salida. El lead
       existia para meter el arranque debajo de la foto y que la junta quedara
       tapada; desde la ronda 3 la cuerda va POR DELANTE y lo que tapa el remate
       es la boca (ver pintaBoca), asi que retrasarlo solo desplazaria las dos
       salidas fuera de las marcas de Oscar. */
    var p0 = { x: maq.salX, y: maq.salY };
    var viaje = xPlomada - p0.x;
    var caida = Math.max(40, maq.giro);
    var p3 = { x: xPlomada, y: p0.y + caida };
    var s = viaje < 0 ? -1 : 1;
    var av = Math.abs(viaje);

    /* El eje sale CAYENDO (ver SALIDA_K arriba). El angulo se mide contra la
       cuerda geometrica hasta la plomada, asi que se adapta solo: donde la
       maquina esta casi encima del canalon (poco viaje) la cuerda es casi
       vertical y la salida sale empinada; donde hay que viajar mucho, se tumba.
       En los dos casos la tangente arranca por DEBAJO de la horizontal. */
    var cuerda = Math.atan2(caida, Math.max(av, 0.001));
    var th = pinza(cuerda * SALIDA_K, SALIDA_MIN, SALIDA_MAX);
    if (th > cuerda - SALIDA_HOLGURA) th = Math.max(0.05, cuerda - SALIDA_HOLGURA);
    var ct = Math.cos(th);
    var st = Math.sin(th);

    /* Brazos de control con MONOTONIA GARANTIZADA, que es lo que mata de raiz
       las dos patologias medidas en la version anterior:
        - en x, el poligono de control no puede pasarse de la plomada
          (L1*cos(th) <= 0.92 del viaje), asi que la curva no se va de largo y
          vuelve: se acabo el rebote de hasta 23,6px que se medi­a a 1024;
        - en y, p1 no puede bajar de p2 (L1*sen(th) + L2 <= caida), asi que no
          hay bucle vertical.
       Con el poligono monotono y las dos tangentes fijadas (th al salir,
       vertical al llegar), el giro se reparte por toda la curva en vez de
       concentrarse en un codo. */
    var L1 = Math.max(0, Math.min((av * 0.92) / Math.max(ct, 0.05), (caida * 0.52) / Math.max(st, 0.05)));
    var L2 = pinza(caida * 0.42, 20, Math.max(20, caida - L1 * st - 4));
    var p1 = { x: p0.x + s * ct * L1, y: p0.y + st * L1 };
    var p2 = { x: p3.x, y: p3.y - L2 };
    var n = pinza(Math.round((Math.abs(viaje) + caida) / 5), 24, 80);
    for (var i = 0; i <= n; i++) {
      var t = i / n;
      var u = 1 - t;
      pts.push({
        x: u * u * u * p0.x + 3 * u * u * t * p1.x + 3 * u * t * t * p2.x + t * t * t * p3.x,
        y: u * u * u * p0.y + 3 * u * u * t * p1.y + 3 * u * t * t * p2.y + t * t * t * p3.y
      });
    }
  }

  /* LA BOCA (20/08/2026, ronda 3). Aqui esta el oficio de esta pieza.

     Criterio nuevo, y conviene que quede escrito para que nadie lo revierta por
     error: **la cuerda se pinta POR DELANTE de la foto de la maquina**, no por
     detras. La ronda 2 la escondia tras la silueta para evitar el efecto
     pegatina y salio peor: se leia como una cuerda que pasa por detras del
     tambor, no como una cuerda que sale de el. Oscar: "las cuerdas tienen que ir
     por encima de la maquina, no por detras; tienen que salir como de la parte
     negra central, como si salieran de dentro".

     Pintar encima SI puede leer como pegatina, y la solucion no es esconderla:
     es que la salida se lea como una BOCA. Tres piezas por hebra, y el orden en
     que se pintan es lo que hace el efecto:

      1. CONTACTO (debajo del cabo, encima de la foto): la sombra que la cuerda
         proyecta sobre el cuerpo del tambor en los primeros pixeles. Va
         desplazada en el sentido contrario a la luz de estudio del cabo
         (LUZ_X/LUZ_Y, arriba-izquierda), asi que cae abajo-derecha, y se
         desvanece con un desenfoque. Sin esto la cuerda flota.
      2. el CABO entero.
      3. BOCA (encima del cabo): un ovalo con degradado radial de negro opaco a
         transparente, centrado en el arranque y orientado con el eje corto a lo
         largo de la cuerda. Se come el remate del trazo, asi que la hebra no
         empieza de golpe: se pierde dentro de una abertura oscura. Y encima un
         LABIO, un arco fino de metal en el borde que mira a la luz, que es lo
         que dice "esto es un agujero en una pieza" en vez de "esto es una mancha".

     Los dos puntos de salida caen sobre negro casi puro del tambor (medido sobre
     el archivo: RGB 10,10,10 en la fila de arriba y 8,8,8 en la de abajo), asi
     que una boca casi negra se funde con el metal y no se ve como un parche. */
  function pintaBoca(tr, hebraW, bocas) {
    /* 22/08/2026: las dos aberturas ya no se deducen del eje. Llegan medidas
       sobre el trazado REAL de cada hebra (`bocas`, que construye() saca del
       primer y del ultimo punto del circuito), asi que cada ovalo se orienta
       con la tangente de SU propia hebra en vez de con una tangente global. Es
       lo que hace que las dos bocas sigan leyendose como agujeros ahora que las
       dos hebras salen con angulos algo distintos. */
    if (!bocas || !bocas.length) return null;
    /* La ranura se mide contra la HEBRA, no contra un radio inventado. Es
       apenas mayor que la cuerda de alto (0.74 de la hebra frente a 0.5 de su
       radio, o sea 2-3px de holgura) y alargada a lo largo del eje, que es lo
       que da el desvanecido del remate. Con un ovalo mas alto que eso el canto
       se despega de la cuerda y vuelve a leerse como un parentesis suelto: el
       tamano ES el efecto. */
    var rx = hebraW * 1.2;
    var ry = hebraW * 0.74;
    var defs = crea('defs', {});
    var grad = crea('radialGradient', { id: 'rrCaboBoca' });
    [['0', '1'], ['0.45', '0.94'], ['0.75', '0.5'], ['1', '0']].forEach(function (p) {
      grad.appendChild(crea('stop', { offset: p[0], 'stop-opacity': p[1] }));
    });
    defs.appendChild(grad);
    var filtro = crea('filter', {
      id: 'rrCaboContacto', x: '-60%', y: '-60%', width: '220%', height: '220%'
    });
    filtro.appendChild(crea('feGaussianBlur', { stdDeviation: (hebraW * 0.22).toFixed(2) }));
    defs.appendChild(filtro);

    var contacto = crea('g', { class: 'rr-cabo__contacto', filter: 'url(#rrCaboContacto)' });
    var tapa = crea('g', { class: 'rr-cabo__boca' });
    tapa.appendChild(defs);

    bocas.forEach(function (boca) {
      var p = { x: boca.x, y: boca.y };
      var t = { x: boca.tx, y: boca.ty };
      /* Sombra de contacto: un trazo corto a lo largo de la cuerda, corrido en
         el sentido opuesto a la luz. Se acorta con el propio desenfoque, asi que
         no hace falta mascara. */
      var largo = hebraW * 2.2;
      contacto.appendChild(crea('path', {
        d: 'M' + (p.x - LUZ_X * hebraW * 0.5).toFixed(2) + ',' +
           (p.y - LUZ_Y * hebraW * 0.5).toFixed(2) +
           'L' + (p.x + t.x * largo - LUZ_X * hebraW * 0.5).toFixed(2) + ',' +
           (p.y + t.y * largo - LUZ_Y * hebraW * 0.5).toFixed(2),
        'stroke-width': (hebraW * 0.8).toFixed(2)
      }));

      var ang = (Math.atan2(t.y, t.x) * 180) / Math.PI;
      var g = crea('g', {
        transform: 'translate(' + p.x.toFixed(2) + ',' + p.y.toFixed(2) + ') rotate(' + ang.toFixed(2) + ')'
      });
      /* El ovalo de la abertura: mas alto que ancho respecto al eje de la
         cuerda, o sea una ranura y no un circulo. Se come el remate del trazo,
         asi que la hebra no empieza de golpe. */
      g.appendChild(crea('ellipse', {
        cx: (hebraW * 0.16).toFixed(2), cy: '0',
        rx: rx.toFixed(2), ry: ry.toFixed(2),
        fill: 'url(#rrCaboBoca)'
      }));
      /* EL LABIO: el canto de la ranura. Va SOBRE EL PROPIO BORDE del ovalo
         (mismos rx/ry), en el cuadrante que mira a la luz de estudio del cabo
         (de 165 a 285 grados: izquierda y arriba). Dos intentos fallidos antes
         de dar con esto, los dos por la misma razon y conviene no repetirla: un
         arco a un radio cualquiera CERCA del arranque se lee como un parentesis
         suelto flotando junto a la cuerda. El canto de un agujero solo se lee
         como tal si coincide exactamente con el borde del agujero, o sea con la
         linea donde el degradado ya se ha ido. */
      /* Sólo el creciente de arriba-izquierda, y un pelo POR DENTRO del borde
         (0.9): el degradado llega a cero justo en el borde del ovalo, asi que un
         arco exactamente encima cae donde ya no hay nada oscuro y vuelve a
         despegarse. */
      var a1 = (188 * Math.PI) / 180;
      var a2 = (282 * Math.PI) / 180;
      var lrx = rx * 0.9;
      var lry = ry * 0.9;
      g.appendChild(crea('path', {
        class: 'rr-cabo__labio',
        d: 'M' + (hebraW * 0.16 + lrx * Math.cos(a1)).toFixed(2) + ',' + (lry * Math.sin(a1)).toFixed(2) +
           'A' + lrx.toFixed(2) + ',' + lry.toFixed(2) + ' 0 0 1 ' +
           (hebraW * 0.16 + lrx * Math.cos(a2)).toFixed(2) + ',' + (lry * Math.sin(a2)).toFixed(2),
        'stroke-width': Math.max(0.6, hebraW * 0.09).toFixed(2)
      }));
      tapa.appendChild(g);
    });
    return { contacto: contacto, tapa: tapa };
  }

  /* Los dos remates del lazo, con la tangente REAL de cada hebra. `circuito` es
     una polilinea cerrada: baja por la hebra de abajo, da la vuelta sobre el
     pasador y sube por la de arriba, asi que sus dos extremos son justo los dos
     puntos por los que la cuerda asoma de la maquina. La tangente se toma sobre
     unos cuantos puntos (no sobre el vecino inmediato, que a este muestreo es
     ruido) y apunta SIEMPRE hacia dentro del trazado, o sea en el sentido en el
     que la cuerda se aleja de la boca. */
  function bocasDelCircuito(circuito) {
    var n = circuito.length;
    if (n < 12) return null;
    var salto = Math.min(8, Math.floor(n / 4));
    function haz(i, j) {
      var a = circuito[i];
      var b = circuito[j];
      var dx = b.x - a.x;
      var dy = b.y - a.y;
      var l = Math.sqrt(dx * dx + dy * dy) || 1;
      return { x: a.x, y: a.y, tx: dx / l, ty: dy / l };
    }
    return [haz(0, salto), haz(n - 1, n - 1 - salto)];
  }

  function recta(pts, x, y) {
    var u = pts[pts.length - 1];
    if (!u || Math.abs(u.x - x) > 0.05 || Math.abs(u.y - y) > 0.05) pts.push({ x: x, y: y });
  }

  /* EL CRUCE: hombro - tendido - hombro (arco / recta / arco).
     La primera versión usaba una interpolación suavizada (smootherstep) que es
     C² contra la vertical, pero que a esta relación de forma da un giro
     malísimo: la banda libre entre dos secciones mide ~150-220px de alto y el
     cruce ~1.265px de ancho, así que el perfil suave se queda pegado a la
     vertical en los extremos y luego tiene que girar de golpe. Medido en vivo a
     1440: radio de curvatura ~6px sobre un cabo de 19px, es decir un codo.

     Un cabo real que cruza un vano no hace eso: sale de la vertical describiendo
     un HOMBRO de radio grande, corre tendido y vuelve a entrar con otro hombro.
     Geométricamente es lo mejor que cabe en la banda: con dos arcos de radio R
     el radio máximo posible es alto/2, y aquí se usa el 42% del alto (~92px a
     1440, 15 veces más redondo que antes).

     `a` es el ángulo del tendido respecto de la vertical, y sale de exigir que
     los dos arcos y la recta sean tangentes entre sí:
        H·sen(a) = W·cos(a) + 2R·(1 - cos a)
     Se resuelve por bisección (la función es monótona y cambia de signo en el
     intervalo, porque R < H/2 por construcción). */
  function cruza(pts, x0, x1, y0, y1) {
    var W = Math.abs(x1 - x0);
    var H = y1 - y0;
    var s = x1 < x0 ? -1 : 1;
    if (W < 0.5 || H <= 0.5) {
      recta(pts, x1, y1);
      return;
    }
    var R = Math.min(H * HOMBRO, W * 0.34, 240);
    var lo = 1e-4;
    var hi = Math.PI / 2 - 1e-4;
    for (var it = 0; it < 44; it++) {
      var m = (lo + hi) / 2;
      if (H * Math.sin(m) - W * Math.cos(m) - 2 * R * (1 - Math.cos(m)) < 0) lo = m;
      else hi = m;
    }
    var a = (lo + hi) / 2;
    var n = pinza(Math.round((R * a) / 4), 10, 90);
    var i;
    for (i = 1; i <= n; i++) {
      var f = (i / n) * a;
      pts.push({ x: x0 + s * R * (1 - Math.cos(f)), y: y0 + R * Math.sin(f) });
    }
    // El salto entre el final del primer arco y el principio del segundo ES el
    // tendido: por la condición de tangencia sale con la misma pendiente.
    for (i = n; i >= 0; i--) {
      var f2 = (i / n) * a;
      pts.push({ x: x1 - s * R * (1 - Math.cos(f2)), y: y1 - R * Math.sin(f2) });
    }
  }

  function trazar(g) {
    var maq = cabezal(g);
    var hebraW = g.grosor * HEBRA;
    var sep0 = g.grosor * SEP;

    /* Pasador del giro de abajo: el cabo da la vuelta alrededor de él, así que
       las dos hebras tienen que abrirse lo justo para abrazarlo. */
    var rPin = Math.max(3, g.grosor * 0.36);
    var sepFin = Math.max(sep0 * 1.25, hebraW * 0.5 + rPin);
    var nariz = sepFin + hebraW * 0.5; // radio exterior del seno

    // En recorrido el cabo nace en el flanco del tambor (salida curva); en
    // colgante sigue naciendo en la boca de abajo, como siempre.
    var yInicio = g.colgante ? maq.ay : maq.y + FOTO.bocaSupYF * maq.h;

    /* MODO COLGANTE (17/08/2026) — móvil.
       Encargo de Oscar: "en móvil el cabo sigue cayendo a la derecha y lo quiero
       centrado". Centrarlo de verdad obliga a cambiar de pieza, no de número, y
       el motivo es geométrico, no de gusto: en un móvil el canalón libre es el
       padding del contenedor (20px a 390), así que el cabo sólo cabe pegado al
       filo de la ventana — de ahí que se lea como el marco de una funda. Y el
       centro de la página está ocupado por el texto en las seis secciones, así
       que una plomada centrada de página entera cruzaría línea de texto en todas
       ellas, que es la regla dura de esta pieza.
       De las dos cosas que Oscar pide (centrado / que recorra la página) sólo
       cabe una, y la que pidió es el centrado. Así que en móvil el cabo deja de
       recorrer la página y se convierte en lo que sí cabe: un SENO COLGANTE
       centrado que sale de la máquina de "Cómo funciona", baja por el eje de la
       página y cierra su vuelta sobre el pasador antes del primer texto. Sigue
       siendo el mismo objeto (dos hebras del mismo cabo sin fin, mismo material,
       mismo pasador de acero), sólo que del tamaño que se puede leer en un
       móvil en vez de una hairline en el filo. La maquetación le hace sitio con
       el hueco de fila de .rr-como__head (ver home.css).
       Para volver al recorrido completo basta con quitar el modo del CSS. */
    if (g.colgante) {
      // 32px de guarda entre el pasador y el primer texto de debajo: medido a
      // 390, con 16 el aro del pasador quedaba a 12px del <h2> y se leía pegado.
      var libre = Math.max(70, maq.espacio) - 32;
      var largo = Math.max(maq.h * 0.55, Math.min(maq.h * 0.95, libre));
      var yFinC = maq.ay + largo;
      var ptsC = [];
      // g.xDer es el eje de la página en este modo (ver medir()).
      asienta(ptsC, maq, g.xDer);
      recta(ptsC, g.xDer, yFinC);
      return {
        /* Colgante: el nacimiento escalonado LATERAL del 17-20/08, intacto. */
        nace: {
          izq: (FOTO.axF - NACE_CENTRO_INT) * maq.w - sep0,
          der: (NACE_CENTRO - FOTO.axF) * maq.w - sep0,
          l: Math.max(40, maq.asiento)
        },
        d: aD(ptsC),
        maq: maq,
        hebraW: hebraW,
        sep0: sep0,
        sepIni: maq.sepIni,
        sepFin: sepFin,
        rPin: rPin,
        nariz: nariz,
        yInicio: yInicio,
        yFin: yFinC,
        alto: yFinC + nariz + 8,
        kGrosor: 1,
        kSep: 1,
        lPersp: 1
      };
    }

    var yFin = g.alto - nariz - 6;

    /* El recorrido ARRANCA POR EL COSTADO DERECHO (17/08/2026). Es el mismo
       zigzag de siempre en espejo: plomada por el canalón derecho, cruce a la
       izquierda por una banda sin contenido, plomada por el izquierdo, y vuelta.
       Todo lo demás (medición, hombros, lazo, arrastre) es simétrico por
       construcción y no cambia: xDer ya se define como vw - xIzq. */
    var x = g.xDer;
    var pts = [];
    salida(pts, maq, x);
    /* Arco real del cuarto de giro, medido sobre lo que acaba de muestrear
       salida(). Es la longitud en la que las dos hebras pasan de nacer una
       encima de otra (separacion VERTICAL, porque el eje sale horizontal) a ir
       de lado con la separacion de regimen. Tiene que estar cerrado ANTES de
       llegar a la plomada: cuando el eje ya baja, esa misma separacion es
       horizontal y no cabria en el canalon. */
    var arcoSalida = 0;
    for (var q = 1; q < pts.length; q++) {
      arcoSalida += Math.hypot(pts[q].x - pts[q - 1].x, pts[q].y - pts[q - 1].y);
    }

    eligeCruces(g).forEach(function (b) {
      var yA = Math.max(b.a, pts[pts.length - 1].y + 24);
      var yB = Math.min(b.b, yFin - 60);
      if (yB - yA < MIN_BANDA * 0.6) return;
      var haciaIzq = Math.abs(x - g.xDer) < 1;
      var x2 = haciaIzq ? g.xIzq : g.xDer;
      recta(pts, x, yA);
      cruza(pts, x, x2, yA, yB);
      x = x2;
    });

    /* Deriva final mínima: por debajo del último bloque de contenido el costado
       está libre, así que el giro puede separarse un par de píxeles del borde si
       hace falta para no salirse de la ventana. Con la misma curva sin codo. */
    var xFin = Math.abs(x - g.xDer) < 1
      ? Math.min(x, g.vw - nariz - 3)
      : Math.max(x, nariz + 3);
    if (Math.abs(xFin - x) > 0.3) {
      var yD = Math.max(pts[pts.length - 1].y + 20, yFin - 90);
      recta(pts, x, yD);
      cruza(pts, x, xFin, yD, yFin);
    } else {
      recta(pts, xFin, yFin);
    }

    /* Cuánta caída necesita la perspectiva. El techo es estético (0.85 del alto
       de la máquina: una cuerda que se aleja, no un embudo), pero manda un límite
       MEDIDO: en cuanto el cabo baja pegado a la columna de contenido, el par ya
       no puede ser más ancho de lo que da el canalón, así que la perspectiva
       tiene que estar hecha para entonces. En escritorio el canalón mide 80-600px
       y no ata nada; en móvil son 20px y la iguala en la caída que hay hasta el
       primer texto. */
    var kGrosor = PERSPECTIVA ? Math.max(1, maq.hebraFoto / hebraW) : 1;
    var kSep = PERSPECTIVA ? Math.max(1, maq.sepIni / sep0) : 1;
    var medioBase = sep0 + hebraW * 0.5;
    /* Holgura del canalón donde cae la primera plomada. Se escribe con xIzq
       aunque desde el 17/08 la plomada de arranque sea la derecha: el contenedor
       está centrado (margin-inline: auto), así que vw - xDer == xIzq y
       xDer - (vw - canal) == canal - xIzq. Las dos expresiones son la misma. */
    var holgura = Math.max(medioBase, Math.min(g.xIzq - 2, g.canal - 3 - g.xIzq));
    function medioPar(r) {
      return sep0 * (1 + (kSep - 1) * r) + (hebraW * (1 + (kGrosor - 1) * r)) / 2;
    }
    var esp = Math.max(60, maq.espacio);
    var lPersp = Math.max(esp, maq.h * PERSP);
    while (lPersp > esp && medioPar(1 - suave(pinza(esp / lPersp, 0, 1))) > holgura) {
      lPersp -= 12;
    }

    return {
      d: aD(pts),
      maq: maq,
      /* Recorrido (22/08/2026): el nacimiento YA NO se fabrica desplazando el
         eje por su normal. Las dos bocas van declaradas (`bocas`, abajo) y el
         desvío que lleva de la posición de régimen a cada boca lo monta
         construye() como vector libre. Aquí el término normal queda en cero: es
         justo lo que quita la cúspide, porque el único desplazamiento por la
         normal que le queda al par es el de régimen (sep0, 9-11px), muy por
         debajo del radio de curvatura del eje en cualquier ancho. */
      nace: {
        izq: 0,
        der: 0,
        l: Math.max(60, arcoSalida * 0.86)
      },
      /* Las dos bocas, en coordenadas de página. `sup` es la de arriba, que es
         la que el lazo dibuja como hebra DERECHA (offset +sep), y `inf` la de
         abajo, que es la IZQUIERDA (offset -sep). */
      bocas: {
        sup: { x: maq.x + FOTO.bocaSupXF * maq.w, y: maq.y + FOTO.bocaSupYF * maq.h },
        inf: { x: maq.x + FOTO.bocaInfXF * maq.w, y: maq.y + FOTO.bocaInfYF * maq.h }
      },
      hebraW: hebraW,
      sep0: sep0,
      sepIni: maq.sepIni,
      sepFin: sepFin,
      rPin: rPin,
      nariz: nariz,
      yInicio: yInicio,
      yFin: yFin,
      /* Perspectiva: cuánto más gorda nace la cuerda que el cabo de página, y en
         cuánta caída se iguala. Los dos factores (grosor y separación) se miden
         por separado porque la sección del cabo fotografiado no tiene las mismas
         proporciones que la del dibujado: en la foto las hebras van más
         separadas en relación con su diámetro. */
      kGrosor: kGrosor,
      kSep: kSep,
      lPersp: lPersp
    };
  }

  /* --------------------------------------------------- muestreo y doble hebra */

  function muestrea(svg, d) {
    if (!medidor) {
      medidor = crea('path', { fill: 'none', stroke: 'none' });
      medidor.setAttribute('aria-hidden', 'true');
    }
    if (medidor.parentNode !== svg) svg.appendChild(medidor);
    medidor.setAttribute('d', d);

    var total = medidor.getTotalLength();
    var pts = [];
    for (var l = 0; l < total; l += PASO) {
      var p = medidor.getPointAtLength(l);
      pts.push({ x: p.x, y: p.y, l: l });
    }
    var fin = medidor.getPointAtLength(total);
    pts.push({ x: fin.x, y: fin.y, l: total });
    return pts;
  }

  /* Desplaza una polilínea por su NORMAL, con distancia variable punto a punto.
     Es lo que mantiene las dos hebras exactamente paralelas también donde el
     cabo va tendido, y lo que permite que se abran al llegar al pasador.

     `vec` (opcional, 22/08/2026) añade encima un desplazamiento LIBRE, que no
     va por la normal. Existe sólo para el nacimiento: permite plantar cada boca
     donde toca sin tener que torcer la tangente del eje para conseguirlo, que
     era el amarre que producía el codo y la cúspide (ver FOTO.bocaSup*). Sin
     `vec` el comportamiento es exactamente el de siempre, así que el modo
     colgante de móvil no se entera. */
  function offset(pts, fn, vec) {
    var out = [];
    for (var i = 0; i < pts.length; i++) {
      var a = pts[Math.max(0, i - 1)];
      var b = pts[Math.min(pts.length - 1, i + 1)];
      var dx = b.x - a.x;
      var dy = b.y - a.y;
      var len = Math.sqrt(dx * dx + dy * dy) || 1;
      var nx = dy / len;
      var ny = -dx / len;
      var d = fn(i, nx, ny);
      var px = pts[i].x + nx * d;
      var py = pts[i].y + ny * d;
      if (vec) {
        var v = vec(i);
        px += v.x;
        py += v.y;
      }
      out.push({ x: px, y: py });
    }
    return out;
  }

  function marco(pts) {
    var n = pts.length;
    var p = pts[n - 1];
    var o = pts[Math.max(0, n - 3)];
    var dx = p.x - o.x;
    var dy = p.y - o.y;
    var l = Math.sqrt(dx * dx + dy * dy) || 1;
    return { x: p.x, y: p.y, tx: dx / l, ty: dy / l, nx: dy / l, ny: -dx / l };
  }

  /* EL LAZO. Las dos "hebras" son en realidad las dos piernas del MISMO cabo sin
     fin: baja por una, da la vuelta sobre el pasador y sube por la otra. Se traza
     como UNA sola polilínea continua, así que no hay ninguna costura y la trenza
     corre por todo el circuito (baja por un lado y sube por el otro). */
  function lazo(pts, sepsIzq, sepsDer, sepFin, vecIzq, vecDer) {
    var izq = offset(pts, function (i) {
      return -sepsIzq[i];
    }, vecIzq);
    var der = offset(pts, function (i) {
      return sepsDer[i];
    }, vecDer);
    var m = marco(pts);

    var out = izq.slice();
    for (var k = 1; k < GIRO_PASOS; k++) {
      var a = (Math.PI * k) / GIRO_PASOS;
      var c = Math.cos(a);
      var s = Math.sin(a);
      out.push({
        x: m.x - m.nx * sepFin * c + m.tx * sepFin * s,
        y: m.y - m.ny * sepFin * c + m.ty * sepFin * s
      });
    }
    for (var j = der.length - 1; j >= 0; j--) out.push(der[j]);
    return out;
  }

  function aD(pts) {
    var s = 'M' + pts[0].x.toFixed(2) + ',' + pts[0].y.toFixed(2);
    for (var i = 1; i < pts.length; i++) {
      s += 'L' + pts[i].x.toFixed(2) + ',' + pts[i].y.toFixed(2);
    }
    return s;
  }

  /* ------------------------------------------------ tramo de perspectiva (15/08)
     El cabo nace midiendo lo que mide el muñón de la foto y adelgaza hasta el
     grosor de página. Como el ancho de trazo de un <path> es constante, ese
     tramo NO se puede pintar con las mismas capas que el resto, así que se
     pinta ENCIMA, con geometría propia y grosor punto a punto:
      - la silueta (sombra, núcleo y canto) va como POLÍGONO RELLENO, que es lo
        único que da un cono perfectamente liso;
      - el sombreado interior (valle, brillo y las dos capas de colcha) va como
        trazos por TRAMOS de factor casi constante. Un escalón del 12% en una
        capa interior no se ve, y así la colcha sigue siendo un dasharray de
        verdad, con su animación intacta: cada tramo lleva su propio
        --rr-cabo-lay, así que el ciclo cierra sin salto y la trenza corre más
        deprisa donde la cuerda está "más cerca", que es justo lo que hace la
        perspectiva. */

  function normalEn(pts, i) {
    var a = pts[Math.max(0, i - 1)];
    var b = pts[Math.min(pts.length - 1, i + 1)];
    var dx = b.x - a.x;
    var dy = b.y - a.y;
    var l = Math.sqrt(dx * dx + dy * dy) || 1;
    return { x: dy / l, y: -dx / l };
  }

  /* Polígono relleno entre dos curvas desplazadas: centro en off x w[i] y medio
     grosor (ancho x w[i]) / 2, todo medido sobre la normal del lazo. */
  function banda(pts, w, i0, i1, off, ancho) {
    var A = [];
    var B = [];
    for (var i = i0; i <= i1; i++) {
      var n = normalEn(pts, i);
      var o = (typeof off === 'function' ? off(n) : off) * w[i];
      var m = (ancho * w[i]) / 2;
      A.push({ x: pts[i].x + n.x * (o + m), y: pts[i].y + n.y * (o + m) });
      B.push({ x: pts[i].x + n.x * (o - m), y: pts[i].y + n.y * (o - m) });
    }
    B.reverse();
    return aD(A.concat(B)) + 'Z';
  }

  /* Corta [i0, i1] en tramos dentro de los cuales el grosor no se aparta más de
     un 12% del de referencia. Los tramos se solapan un punto para que no quede
     ninguna rendija entre ellos. */
  function tramosDeGrosor(w, i0, i1) {
    var out = [];
    var a = i0;
    var ref = w[i0];
    for (var i = i0 + 1; i <= i1; i++) {
      if (Math.max(w[i], ref) / Math.min(w[i], ref) > 1.12) {
        out.push({ a: a, b: i, w: (ref + w[i]) / 2 });
        a = i;
        ref = w[i];
      }
    }
    if (i1 > a) out.push({ a: a, b: i1, w: (ref + w[i1]) / 2 });
    return out;
  }

  /* Polilínea desplazada por la normal, con distancia proporcional al grosor
     local: es el eje de una capa de sombreado dentro del tramo. */
  function ejeDesplazado(pts, w, i0, i1, off) {
    var out = [];
    for (var i = i0; i <= i1; i++) {
      var n = normalEn(pts, i);
      var o = (typeof off === 'function' ? off(n) : off) * w[i];
      out.push({ x: pts[i].x + n.x * o, y: pts[i].y + n.y * o });
    }
    return out;
  }

  /* ------------------------------------------------------------- el trenzado
     (19/08/2026) El cabo de la máquina es TRENZADO, no colchado. Medido sobre la
     macro del producto (media-pendiente/_cabo/revorope-cabo-cabezal-CON-CUERDA
     .webp), con el eje enderezado y FFT del parche de la cara visible:
       - dos familias de picos a +38.9 y -37.2 grados del eje (energías 124k y
         52k), o sea una ESPIGA, no una torsión de tres cordones;
       - paso a lo largo del eje 6.1px sobre un diámetro de 25px = 0.244 D,
         constante en los tres tercios de la cara (5.8 / 6.4 / 4.9);
       - separación transversal 4.92px = 5 columnas de pico por diámetro.

     Cómo se dibuja, y por qué así. Un pico es una raya a ANG grados del eje. Se
     RASTERIZA en carriles paralelos al eje: si dos carriles distan dU, la misma
     raya los cruza con un desfase dS = dU/tan(ANG) a lo largo del eje. O sea que
     basta un trazo DISCONTINUO por carril, cada uno con su fase. Es la única
     construcción que encontré que dibuja el trenzado y deja intacta la firma de
     la pieza: como cada carril es un dash A LO LARGO DEL EJE, stroke-dashoffset
     lo sigue moviendo, y la trenza corre al hacer scroll o al arrastrar.
     (Se descartó el zigzag, que sí dibuja el pico pero al desplazarlo por
     dashoffset la marca gira en vez de avanzar; y el patrón SVG, que no sigue la
     curva y saldría cruzado en los tramos tendidos, que son un tercio del
     recorrido.)

     Dos condiciones duras, las dos comprobadas mirando el render:
      1. dS tiene que quedar bastante por debajo del paso o el escalonado se
         alias y las rayas se leen HORIZONTALES. Con dS/paso <= 1/3 va bien.
      2. Las dos familias NO se pintan en todos los carriles: eso da una malla de
         equis que se lee como red, no como cabo. Van por BLOQUES de carriles con
         inclinaciones alternas, que es lo que produce los chevrones de la espiga
         (y es lo que se ve en la foto). */
  function pintaTrenza(frag, circuito, D, cfg, addPath, capa) {
    var N = Math.max(2, Math.round(cfg.carriles));
    var tan = Math.tan((cfg.angulo * Math.PI) / 180) || 1;
    var lay = cfg.lay;
    var w = D * 0.15;
    var maxU = Math.max(0, (D - w) / 2);
    var dU = (2 * maxU) / (N - 1);
    var dS = dU / tan;
    var bloque = Math.max(1, Math.round(cfg.bloque));

    function signoDe(j) {
      return Math.floor(j / bloque) % 2 ? -1 : 1;
    }
    /* Fase acumulada: dentro de un bloque avanza con su signo y al cambiar de
       bloque sigue desde donde iba, así que la costura entre bloques es un
       vértice del chevrón y no un salto. */
    var fases = [];
    var f = 0;
    for (var j = 0; j < N; j++) {
      if (j) f += signoDe(j) * dS;
      fases.push(f);
    }

    /* TROCEADO PARA QUE EL COSTE SEA EL DE LO QUE SE VE (19/08/2026).
       Medido con Chrome real: el gasto por fotograma de este dibujo es
       EXACTAMENTE proporcional al número total de guiones que el navegador tiene
       que recalcular cuando cambia stroke-dashoffset, y no depende ni del número
       de trazados ni de su longitud (13 carriles con el paso x8 cuestan lo mismo
       que sin discontinuo: 8,3 ms). Con el lazo entero (14.500 px) y un paso de
       6,2 px salían 91.000 guiones por fotograma y la mediana subía de 8,3 ms a
       40,6 ms, o sea 24 fps al hacer scroll: inaceptable.
       El lazo mide 14.500 px pero en pantalla nunca hay más de ~2.000, así que
       cada carril se corta en TROZOS y sólo corren los que caen cerca de la
       ventana (clase is-corriendo). Los demás se quedan con su fase fija: como se
       activan con un margen de una ventana entera por arriba y otra por abajo,
       ninguno cambia de estado estando a la vista.
       Los trozos se solapan lay*1.5 para que el remate redondo de un guión
       cortado por el borde del trozo caiga siempre dentro del trozo vecino, que
       pinta exactamente el mismo patrón (misma fase global). */
    var TROZO = 1150;
    var solape = lay * 1.5;

    function acumulado(pts) {
      var a = [0];
      for (var q = 1; q < pts.length; q++) {
        a.push(a[q - 1] + Math.hypot(pts[q].x - pts[q - 1].x, pts[q].y - pts[q - 1].y));
      }
      return a;
    }

    function indiceDeArco(acum, s) {
      var lo = 0;
      var hi = acum.length - 1;
      while (lo < hi) {
        var md = (lo + hi) >> 1;
        if (acum[md] < s) lo = md + 1;
        else hi = md;
      }
      return lo;
    }

    function carril(j, clase, ancho, extraFase) {
      var u = -maxU + j * dU;
      var eje = offset(circuito, function () {
        return u;
      });
      /* El arco se mide sobre EL PROPIO CARRIL, no sobre el eje del lazo: al
         desplazar por la normal, el carril de fuera de una curva se alarga y el
         de dentro se acorta, así que usar el arco del eje metía una deriva de
         fase que crecía tras cada cruce (medido: hasta 2,9 px de un paso de 6,19,
         o sea casi medio patrón; lo cazó la prueba de continuidad). */
      var acum = acumulado(eje);
      var total = acum[acum.length - 1];
      var nTrozos = Math.max(1, Math.round(total / TROZO));
      var largo = total / nTrozos;
      for (var t = 0; t < nTrozos; t++) {
        var ia = indiceDeArco(acum, Math.max(0, t * largo - solape));
        var ib = indiceDeArco(acum, Math.min(total, (t + 1) * largo + solape));
        if (ib - ia < 1) continue;
        var tramo = eje.slice(ia, ib + 1);
        var p = addPath('rr-cabo__trenza ' + clase, aD(tramo), ancho, {
          'stroke-dasharray': (lay * 0.5).toFixed(3) + ' ' + (lay * 0.5).toFixed(3),
          // arco global donde arranca el trozo y carril al que pertenece: no los
          // usa el dibujo, son el gancho de la prueba de costura (verificar que
          // el patrón es continuo de un trozo al siguiente).
          'data-arco': acum[ia].toFixed(2),
          'data-carril': j
        });
        /* Fase del trozo: la que tendría el trazado entero en ese punto del arco,
           para que el patrón sea continuo de un trozo al siguiente.
           stroke-dashoffset avanza el patrón, así que en el arco s el patrón va
           por (s + fase) mod paso; si el trozo empieza en el arco `a`, su fase
           propia tiene que ser fase + a (no fase - a: ese error de signo dejaba
           medio paso de desajuste entre trozos, cazado con la misma prueba). */
        var fase = (((fases[j] + (extraFase || 0) + acum[ia]) % lay) + lay) % lay;
        p.style.setProperty('--rr-cabo-fase', fase.toFixed(3) + 'px');
        var y0 = Infinity;
        var y1 = -Infinity;
        for (var v = 0; v < tramo.length; v++) {
          if (tramo[v].y < y0) y0 = tramo[v].y;
          if (tramo[v].y > y1) y1 = tramo[v].y;
        }
        trozos.push({ el: p, y0: y0, y1: y1 });
      }
    }

    for (var k = 0; k < N; k++) {
      if (capa === 'surco-alto') {
        // El mismo surco, pero fino y por encima del sombreado: un rebaje corta
        // también el brillo del filo. Sin esto el especular sale como una raya de
        // plástico continua; con él, el filo iluminado se rompe en una hilera de
        // destellos, que es lo que hace la cuerda real (medido en la macro: en la
        // cara iluminada el brillo no es una línea, es una sucesión de picos).
        carril(k, 'rr-cabo__surco-alto', w * 0.66, 0);
      } else if (capa === 'surco') {
        // Surco: donde un cordón se mete bajo el otro. Algo más ancho que la
        // cresta y SIEMPRE por encima del sombreado: un surco es un rebaje, así
        // que corta también el brillo del filo (si no, el especular sale como una
        // raya de plástico continua y el trenzado no se le nota).
        carril(k, 'rr-cabo__surco', w * 1.12, 0);
      } else {
        // Cresta: media galga desfasada, o sea justo entre dos surcos, que es
        // donde está el lomo del cordón en un cabo real. Va DEBAJO del sombreado
        // para que la mitad en sombra la apague.
        carril(k, 'rr-cabo__cresta', w, lay * 0.5);
      }
    }
    return { lay: lay, dU: dU, dS: dS, ratio: dS / lay, carriles: N };
  }

  /* -------------------------------------------------------------- el herraje */

  /* Pinta la máquina de la que sale el cabo. Va la ÚLTIMA de todas las capas, o
     sea por delante del cabo: así el tramo de cuerda dibujada que ataca dentro
     de la foto queda tapado por la cuerda fotografiada y no se ve ninguna
     costura. Si por lo que sea no hay archivo, no se pinta nada: el cabo sigue
     saliendo del canalón y el adorno degrada a menos, nunca a roto. */
  function pintaMaquina(tr, url) {
    if (!url) return null;
    var m = tr.maq;
    var im = crea('image', {
      class: 'rr-cabo__maquina',
      x: m.x.toFixed(1),
      y: m.y.toFixed(1),
      width: m.w.toFixed(1),
      height: m.h.toFixed(1),
      preserveAspectRatio: 'xMidYMid meet'
    });
    im.setAttribute('href', url);
    // Respaldo para motores que aún esperan el href de xlink en <image>.
    im.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', url);
    return im;
  }

  /* EL PASADOR. Sustituye al remate encapillado: abajo el cabo ya no se corta ni
     se ata, DA LA VUELTA sobre este eje y sube por la otra pierna. Va detrás del
     cabo, así que el seno lo abraza y solo se ve el disco por el hueco que dejan
     las dos hebras: el pasador queda ENTRE ellas, que es justo lo que se pidió.
     Mismo lenguaje de material que los pernos del cabezal (acero, nunca rojo). */
  function pintaPasador(tr, m) {
    var r = tr.rPin;
    var grupo = crea('g', {
      transform: 'translate(' + m.x.toFixed(1) + ',' + m.y.toFixed(1) + ')'
    });
    // Un pelo más grande que el hueco: el borde se mete bajo el cabo y se lee
    // como eje abrazado, no como pegatina.
    grupo.appendChild(crea('circle', { class: 'rr-cabo__acero', cx: 0, cy: 0, r: (r * 1.22).toFixed(2) }));
    grupo.appendChild(
      crea('circle', { class: 'rr-cabo__hueco', cx: 0, cy: 0, r: Math.max(1, r * 0.44).toFixed(2) })
    );
    grupo.appendChild(
      crea('path', {
        class: 'rr-cabo__brillo-linea',
        d:
          'M' + (-r * 0.66).toFixed(2) + ',' + (-r * 0.44).toFixed(2) +
          'A' + (r * 0.8).toFixed(2) + ',' + (r * 0.8).toFixed(2) + ' 0 0 1 ' +
          (r * 0.28).toFixed(2) + ',' + (-r * 0.75).toFixed(2)
      })
    );
    return grupo;
  }

  /* Collarín: guía metálica que abraza las DOS hebras, sobre el trazado y girada
     con su tangente, así que funciona esté el cabo donde esté en ese punto. */
  function pintaCollarin(g, tr, pts, yObjetivo) {
    var idx = 0;
    var mejor = Infinity;
    for (var i = 0; i < pts.length; i++) {
      var d = Math.abs(pts[i].y - yObjetivo);
      if (d < mejor) {
        mejor = d;
        idx = i;
      }
    }
    var p = pts[idx];
    var a = pts[Math.max(0, idx - 2)];
    var b = pts[Math.min(pts.length - 1, idx + 2)];
    var ang = (Math.atan2(b.y - a.y, b.x - a.x) * 180) / Math.PI - 90;
    var w = (2 * tr.sep0 + tr.hebraW) * 1.26;
    var h = g.grosor * 1.25;
    var grupo = crea('g', {
      transform: 'translate(' + p.x.toFixed(1) + ',' + p.y.toFixed(1) + ') rotate(' + ang.toFixed(1) + ')'
    });
    grupo.appendChild(
      crea('rect', {
        class: 'rr-cabo__carcasa',
        x: (-w / 2).toFixed(1),
        y: (-h / 2).toFixed(1),
        width: w.toFixed(1),
        height: h.toFixed(1),
        rx: 3
      })
    );
    grupo.appendChild(
      crea('rect', {
        class: 'rr-cabo__brillo',
        x: (-w / 2 + 2).toFixed(1),
        y: (-h / 2 + 1.5).toFixed(1),
        width: (w - 4).toFixed(1),
        height: Math.max(1, h * 0.12).toFixed(1),
        rx: 1
      })
    );
    return grupo;
  }

  /* -------------------------------------------------------------- el montaje */

  function construye() {
    if (!anclas.length) return;

    var g = medir();
    if (!(g.alto > 200) || !(g.vw > 0)) return;

    var tr = trazar(g);
    var host = anclas[0].el;
    trozos = [];
    arribaLienzo = g.arriba;

    if (!lienzo) {
      var svg = crea('svg', { class: 'rr-cabo__svg', xmlns: SVGNS });
      svg.setAttribute('aria-hidden', 'true');
      host.appendChild(svg);
      lienzo = { host: host, svg: svg };
    }
    var svgEl = lienzo.svg;

    // El anclaje del primer tramo se estira a TODA la tirada; el resto son
    // marcadores vacíos que solo aportan medida y papel. En modo colgante la
    // tirada acaba en el propio seno, no al final de la página.
    var altoLienzo = g.colgante ? tr.alto : g.alto;
    host.style.height = altoLienzo + 'px';
    // Sin viewBox y con width/height en px: escala 1:1, el trazo no se deforma.
    svgEl.setAttribute('width', g.vw);
    svgEl.setAttribute('height', Math.ceil(altoLienzo));

    var pts = muestrea(svgEl, tr.d);
    if (pts.length < 4) return;

    var hebraW = tr.hebraW;

    /* Apertura de las hebras para abrazar el pasador. Ocurre SOLO por debajo del
       último bloque de contenido: ahí el costado está libre, así que el par puede
       ensancharse sin acercarse a ninguna línea de texto. */
    var lTot = pts[pts.length - 1].l;
    // En colgante la vuelta ocurre al final del propio seno, no debajo del
    // último bloque de contenido de la página.
    var yLibre = g.colgante
      ? tr.yFin - 50
      : g.tramos[g.tramos.length - 1].contAbajo - g.arriba + 10;
    var lLibre = lTot;
    for (var i = 0; i < pts.length; i++) {
      if (pts[i].y >= yLibre) {
        lLibre = pts[i].l;
        break;
      }
    }
    var abre = pinza(lTot - lLibre, 30, 150);
    var l0 = lTot - abre;

    /* PERSPECTIVA. Arriba la cuerda nace midiendo lo que mide el muñón de la
       foto: más gorda y con las hebras más separadas (en la foto viene hacia la
       cámara). Las dos cosas se igualan al cabo de página a lo largo de la misma
       caída, con la misma rampa, así que toda la sección se aleja a la vez.
       Abajo las hebras se vuelven a abrir para abrazar el pasador: las dos
       aperturas viven en el mismo array porque no se solapan (una al principio,
       la otra al final). */
    function rampa(l) {
      return 1 - suave(pinza(l / tr.lPersp, 0, 1)); // 1 en la foto -> 0 de página
    }
    var seps = pts.map(function (p) {
      return (
        tr.sep0 * (1 + (tr.kSep - 1) * rampa(p.l)) +
        (tr.sepFin - tr.sep0) * suave(pinza((p.l - l0) / abre, 0, 1))
      );
    });
    var anchoIzq = pts.map(function (p) {
      return hebraW * (1 + (tr.kGrosor - 1) * rampa(p.l));
    });

    /* EL NACIMIENTO. Los dos modos comparten esta rampa, pero desde el
       22/08/2026 la montan de forma distinta:
        - colgante (móvil): INTACTO. Cada hebra tiene su propia columna de
          nacimiento sobre la foto (una abre y la otra cierra), como desvío por
          la NORMAL. Es el mecanismo del 17-20/08 y no se toca.
        - recorrido (escritorio): el desvío por la normal es cero y en su lugar
          va un VECTOR LIBRE por hebra, que lleva de la posición de régimen a la
          boca declarada. Dos cosas se arreglan con eso a la vez: el eje queda
          libre de salir cayendo (ya no tiene que ir casi horizontal para que la
          normal separe las bocas en altura), y el desplazamiento que sufre la
          curva vuelve a ser sólo el de régimen, muy por debajo de su radio, así
          que desaparece la cúspide.
       En los dos casos se cierra con smootherstep y llega a la plomada con el
       par ya asentado y sin quiebro. */
    var vecIzq = null;
    var vecDer = null;
    var lNace = tr.nace.l;
    if (tr.bocas) {
      var n0 = normalEn(pts, 0);
      var s0 = seps[0];
      /* De dónde saldría cada hebra si sólo hubiera separación de régimen, y
         cuánto hay que corregir para plantarla en su boca. `der` es +normal (la
         de arriba) y `izq` es -normal (la de abajo), igual que en lazo(). */
      var dDer = {
        x: tr.bocas.sup.x - (pts[0].x + n0.x * s0),
        y: tr.bocas.sup.y - (pts[0].y + n0.y * s0)
      };
      var dIzq = {
        x: tr.bocas.inf.x - (pts[0].x - n0.x * s0),
        y: tr.bocas.inf.y - (pts[0].y - n0.y * s0)
      };
      /* El desvío tiene que cerrarse en arco suficiente para que ninguna hebra
         tenga que remontar mientras se acerca a la otra (ver NACE_K). */
      var modMax = Math.max(Math.hypot(dDer.x, dDer.y), Math.hypot(dIzq.x, dIzq.y));
      lNace = Math.max(lNace, modMax * NACE_K);
    }
    /* RETEN: el primer tramo NO cierra nada. Es lo que hace que la separacion
       este ahi desde el primer pixel en vez de ganarse (o perderse) por el
       camino: con la smootherstep pelada, para cuando asoma la segunda hebra la
       primera ya habia cerrado la mitad de su desvio. */
    var RETEN = 0.28;
    function cierraEn(l, L) {
      return 1 - suave(pinza((l / L - RETEN) / (1 - RETEN), 0, 1));
    }
    function cierra(l) {
      return cierraEn(l, lNace);
    }
    var sepsDer = pts.map(function (p, i) {
      return seps[i] + tr.nace.der * cierra(p.l);
    });
    var sepsIzq = pts.map(function (p, i) {
      return seps[i] + tr.nace.izq * cierra(p.l);
    });
    if (tr.bocas) {
      /* SUELO DE SEPARACION (22/08/2026). Las dos hebras son simetricas
         respecto del eje (dIzq == -dDer por construccion, porque las dos bocas
         son simetricas respecto del punto de salida), asi que su separacion en
         un mismo punto del eje vale 2x el vector v = n*sep + k*dDer. Esos dos
         sumandos giran a ritmos distintos (la normal se endereza con el eje y
         el desvio de nacimiento no), asi que en principio podrian llegar a
         restarse. El suelo lo impide: si el modulo se queda por debajo de la
         separacion de regimen, se reescala a ella. Como la correccion es sobre
         el modulo y no sobre la direccion, no mete ningun quiebro.

         HONESTIDAD SOBRE LO QUE ESTO **NO** ARREGLA, para que nadie lo de por
         cerrado leyendo el nombre: es una barandilla, no la solucion del
         estrechamiento que se mide a 1024. Medido antes y despues de ponerlo,
         el hueco minimo real a 1024 pasa de 3,44 a 3,59px (regimen 5,41), o sea
         nada. El motivo es que este suelo trabaja punto a punto del EJE, y el
         minimo real entre las dos hebras a 1024 no ocurre entre puntos
         homologos: el desvio de nacimiento es casi todo TANGENCIAL a esa
         anchura (la boca de arriba queda "por detras" del arranque a lo largo
         del eje), y un desvio tangencial CIZALLA el par, que es un efecto que
         ninguna correccion de modulo por punto puede ver. Se probaron y se
         descartaron por medicion tres palancas para ese resto: alargar el
         cierre (NACE_K 6/8/10 lo empeora hasta solaparlas), acortarlo
         (arcoSalida*0.60 lo arregla pero deja el codo de la hebra de abajo en
         R=17px) y bajar el tope de angulo (SALIDA_MAX 46/42: mueve el hueco de
         2,71 a 2,64, nada). Se deja como esta: a 1024 el par queda a 11,7px de
         centro a centro en vez de 14,4, un 19% mas junto en UN punto, y
         comprobado en captura a 6x que se siguen leyendo dos cuerdas. De 1280
         en adelante el hueco es >= regimen en todo el recorrido. */
      /* El desvío de nacimiento se cierra con DOS relojes, uno por eje, y no por
         capricho: cerca de la plomada el par baja vertical, así que la
         componente X es la que fija LA SEPARACIÓN entre las dos hebras y la Y es
         puro deslizamiento a lo largo del propio recorrido. Separarlas permite
         alargar sólo lo que hace falta (la subida de la hebra de abajo, que es
         lo que produce el codo) sin tocar en absoluto lo que las mantiene
         apartadas. Estirar las dos a la vez, que fue el primer intento, sube el
         radio a 104px pero mete las hebras una dentro de la otra (hueco medido
         -0,41px): la X arrastraba la hebra de abajo hacia la de arriba. */
      var vec = function (signo, Lx, Ly) {
        return function (i) {
          var n = normalEn(pts, i);
          var s = seps[i];
          var kx = cierraEn(pts[i].l, Lx);
          var ky = cierraEn(pts[i].l, Ly);
          var vx = n.x * s + dDer.x * kx;
          var vy = n.y * s + dDer.y * ky;
          var mod = Math.sqrt(vx * vx + vy * vy);
          if (mod > 0.01 && mod < s) {
            vx *= s / mod;
            vy *= s / mod;
          }
          // offset() ya suma n*s por su cuenta: aqui solo va la correccion.
          return { x: signo * (vx - n.x * s), y: signo * (vy - n.y * s) };
        };
      };
      /* CIERRE ASIMETRICO (22/08/2026). Encargo de Oscar sobre una captura con la
         curva que quiere dibujada a mano encima de la hebra de abajo: que salga
         de su misma boca pero describiendo un arco ancho y gradual, abriendose
         de la de arriba antes y quedando mas separada, sin ningun quiebro.

         La causa medida de que hoy no lo haga: las dos hebras cierran su desvio
         de nacimiento en el MISMO arco, y con un eje que baja eso no les cuesta
         lo mismo. La de ARRIBA nace por encima del eje y tiene que bajar para
         juntarse, o sea que su correccion va A FAVOR de la caida del eje y sale
         redonda sola. La de ABAJO nace por debajo y tiene que SUBIR mientras el
         eje baja: las dos velocidades se cancelan, la hebra sale casi plana y
         luego tiene que doblar de golpe para engancharse a la plomada. Medido
         antes de tocar nada: radio minimo 121-126px en la de arriba frente a
         27-33px en la de abajo, o sea cuatro veces mas cerrada. Eso es el codo
         que Oscar esta viendo.

         El arreglo no es mover la boca ni el eje (los dos estan aprobados): es
         darle a la hebra de abajo MAS ARCO para hacer el mismo trabajo. Con el
         cierre repartido en NACE_INF veces mas recorrido, la correccion por
         pixel baja en la misma proporcion y el radio sube; y de paso el par se
         mantiene abierto mas rato, que es la otra mitad del encargo. */
      vecDer = vec(1, lNace, lNace);
      vecIzq = vec(-1, lNace, lNace * NACE_INF);
    }

    var m = marco(pts);
    var circuito = lazo(pts, sepsIzq, sepsDer, tr.sepFin, vecIzq, vecDer);
    var dEje = aD(simplifica(pts, TOL_SIMPLIFICA));

    /* Grosor punto a punto sobre el LAZO, con la misma construcción que lazo():
       pierna de bajada + giro + pierna de subida al revés. */
    var anchoCirc = anchoIzq.slice();
    for (var t = 1; t < GIRO_PASOS; t++) anchoCirc.push(hebraW);
    for (var u = anchoIzq.length - 1; u >= 0; u--) anchoCirc.push(anchoIzq[u]);

    var lay = 0; // paso del trenzado en px; se calcula abajo con la galga real
    var capas = document.createDocumentFragment();

    function add(clase, d, ancho, extra) {
      var p = crea('path', { class: clase, d: d, 'stroke-width': ancho.toFixed(2) });
      if (extra) {
        for (var k in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, k)) p.setAttribute(k, extra[k]);
        }
      }
      capas.appendChild(p);
      return p;
    }

    /* SIMPLIFICACIÓN (19/08/2026). El cabo trenzado pinta una capa por carril, así
       que el trazado se simplifica antes de generarlas: los tramos de plomada son
       rectos y venían muestreados cada 8px de arco. Se salta si la perspectiva
       está encendida, porque ahí hay un ancho por punto (anchoCirc) que perdería
       la correspondencia de índices. */
    var pintado = tr.kGrosor > 1.02 ? circuito : simplifica(circuito, TOL_SIMPLIFICA);

    // El pasador va DEBAJO del cabo: el seno lo abraza y solo asoma por el hueco
    // que dejan las dos hebras.
    capas.appendChild(pintaPasador(tr, m));

    // Sombra proyectada: despega el cabo de las superficies claras. Ahora es una
    // por hebra (van separadas), no un único borrón bajo el par.
    var sombra = add('rr-cabo__sombra', aD(pintado), hebraW * 1.12);
    sombra.setAttribute('transform', 'translate(1.2,1.9)');

    // Cuerpo opaco de la hebra.
    add('rr-cabo__nucleo', aD(pintado), hebraW);

    /* Los DOS filos. Un cilindro cae por los dos cantos, no sólo por el de fuera:
       es lo que separa "dos cilindros con aire entre ellos" de "una cinta plana".
       Sustituye a __canto (sólo fuera) y __valle (sólo dentro), que dejaban la
       hebra con un canto oscuro y el otro no. */
    add(
      'rr-cabo__rim',
      aD(offset(pintado, function () {
        return -hebraW * 0.4;
      })),
      hebraW * 0.22
    );
    add(
      'rr-cabo__rim',
      aD(offset(pintado, function () {
        return hebraW * 0.4;
      })),
      hebraW * 0.22
    );

    /* EL TRENZADO, debajo del sombreado. Ver pintaTrenza(): el paso sale de la
       galga declarada en CSS (--rr-cabo-paso, fracción del diámetro de la hebra)
       y de ahí se deriva --rr-cabo-lay, que es lo que consume la animación. */
    /* El paso se CUANTIZA a múltiplos de 0.002 px. No es manía: el patrón se
       pinta con un stroke-dasharray escrito con 3 decimales, así que el paso que
       de verdad usa el navegador es el redondeado; si la fase de cada trozo se
       calcula con el paso sin redondear, la diferencia (milésimas) se acumula a lo
       largo de los 14.000 px del lazo y acaba dando casi medio patrón de
       desajuste entre el primer trozo y el del medio. Cuantizado, la mitad del
       paso es exacta a 3 decimales y las dos cuentas hablan del mismo número.
       (Medido antes de cuantizar: 2,90 px de desfase sobre un paso de 6,19.) */
    lay = Math.max(0.2, Math.round(hebraW * numVar(host, '--rr-cabo-paso', 0.58) * 500) / 500);
    var cfgTrenza = {
      lay: lay,
      carriles: numVar(host, '--rr-cabo-carriles', 9),
      bloque: numVar(host, '--rr-cabo-bloque', 3),
      angulo: numVar(host, '--rr-cabo-angulo', 38)
    };
    var trenza = pintaTrenza(capas, pintado, hebraW, cfgTrenza, add, 'cresta');
    pintaTrenza(capas, pintado, hebraW, cfgTrenza, add, 'surco');
    host.style.setProperty('--rr-cabo-lay', lay.toFixed(3) + 'px');

    /* SOMBREADO CILÍNDRICO, anclado a la luz (arriba-izquierda). Va ENCIMA del
       trenzado, así que la mitad de la hebra que no mira a la luz lo apaga sola:
       en la foto real la mitad en sombra es negra y lisa, el dibujo sólo se lee
       en la cara iluminada. Se proyecta la luz sobre la normal del lazo, así que
       la cara iluminada gira sola al dar la vuelta abajo en vez de quedarse
       pegada a un costado. */
    function haciaLuz(k) {
      return function (i, nx, ny) {
        return (LUZ_X * nx + LUZ_Y * ny) * hebraW * k;
      };
    }
    add('rr-cabo__ocluye', aD(offset(pintado, haciaLuz(-0.24))), hebraW * 0.48);
    add('rr-cabo__cara', aD(offset(pintado, haciaLuz(0.26))), hebraW * 0.3);
    add('rr-cabo__luz', aD(offset(pintado, haciaLuz(0.375))), hebraW * 0.09);

    // Y por último los SURCOS, por encima de todo: un surco es un rebaje del
    // trenzado, así que también recorta el filo brillante. Sin esto el especular
    // sale como una raya continua y el cabo se lee como un tubo de plástico con
    // dibujo por debajo, no como una cuerda.
    pintaTrenza(capas, pintado, hebraW, cfgTrenza, add, 'surco-alto');

    /* --- El tramo de perspectiva, ENCIMA de lo anterior -----------------------
       Donde la cuerda es más gorda que el cabo de página se vuelve a pintar con
       geometría propia. Va después a propósito: el núcleo relleno es opaco y más
       ancho, así que tapa por completo las capas de grosor constante y no hace
       falta recortar nada. Como la rampa llega a 1 con derivada nula, el relevo
       ocurre justo donde los dos anchos coinciden. */
    function pintaPerspectiva(i0, i1) {
      if (i1 - i0 < 2) return;

      function rellena(clase, off, ancho, tras) {
        var p = crea('path', {
          class: 'rr-cabo__relleno rr-cabo__relleno--' + clase,
          d: banda(circuito, anchoCirc, i0, i1, off, ancho)
        });
        if (tras) p.setAttribute('transform', tras);
        capas.appendChild(p);
      }

      rellena('sombra', 0, 1.12, 'translate(1.2,1.9)');
      rellena('nucleo', 0, 1);
      // Canto un punto más ancho que en el cabo fino (0.42 frente a 0.36): a este
      // tamaño el borde oscuro es lo que da el volumen cilíndrico, y la
      // diferencia sólo vale 0,5 px donde los dos anchos se relevan.
      rellena('canto', -0.29, 0.42);

      tramosDeGrosor(anchoCirc, i0, i1).forEach(function (t) {
        var f = t.w / hebraW;
        /* Los realces se APAGAN a medida que la cuerda engorda. No es un ajuste
           a ojo: el cabo fotografiado de esta máquina es casi negro (medido
           sobre el archivo, media RGB 16,15,19 y percentil 90 en 44), mientras
           que el modelo de brillo del cabo dibujado, pensado para 8 px de hebra,
           llevaría el interior a 85 al escalarlo x3.3. Sin apagarlos, la cuerda
           dibujada sale gris junto a una foto negra y la junta canta.
           16/08/2026: apagado CUADRÁTICO en vez de lineal. Con el cabo un 20%
           más gordo y la máquina un 10% más pequeña, el 1/f lineal dejaba el
           realce en 0.43 y el tramo de nacimiento se leía como un rosario de
           cuentas grises (justo el fallo que este bloque intenta evitar). Con
           1/f² el pico de blanco baja de ~105 a ~45, que es el percentil 90
           medido en la cuerda fotografiada. */
        var apaga = pinza(1 / (f * f), 0.12, 1);

        function traza(clase, off, ancho, extra, fase, op) {
          var p = crea('path', {
            class: clase,
            d: aD(ejeDesplazado(circuito, anchoCirc, t.a, t.b, off)),
            'stroke-width': (ancho * t.w).toFixed(2)
          });
          if (extra) {
            for (var k in extra) {
              if (Object.prototype.hasOwnProperty.call(extra, k)) p.setAttribute(k, extra[k]);
            }
          }
          if (op !== undefined) p.setAttribute('opacity', op.toFixed(3));
          // Su propio paso de colcha: el ciclo de la animación mide lo mismo que
          // el dasharray, así que cierra sin salto y la trenza corre más deprisa
          // donde la cuerda está más cerca, que es lo que hace la perspectiva.
          p.style.setProperty('--rr-cabo-lay', (lay * f).toFixed(2) + 'px');
          if (fase !== undefined) p.style.setProperty('--rr-cabo-fase', fase);
          capas.appendChild(p);
        }

        traza('rr-cabo__rim', 0.3, 0.3);
        traza(
          'rr-cabo__luz',
          function (n) {
            return (LUZ_X * n.x + LUZ_Y * n.y) * 0.26;
          },
          0.3,
          null,
          undefined,
          apaga
        );
        var paso = lay * f;
        // La cincha oscura también se atenúa al engordar (16/08/2026): a plena
        // opacidad sobre una hebra gruesa deja de leerse como el valle del
        // colchado y se lee como una correa negra que parte la cuerda en tramos.
        traza(
          'rr-cabo__trenza rr-cabo__surco',
          0,
          0.98,
          { 'stroke-dasharray': (2.4 * f).toFixed(1) + ' ' + (paso - 2.4 * f).toFixed(1) },
          '0px',
          0.3 + 0.7 * apaga
        );
        // La cápsula de colcha se estrecha además de apagarse: a 0.72 del ancho
        // sobre una hebra de 28 px deja de leerse como el lay de un cabo y se
        // lee como una cuenta.
        traza(
          'rr-cabo__trenza rr-cabo__cresta',
          0,
          0.72 - 0.22 * (1 - apaga),
          { 'stroke-dasharray': (paso * 0.5).toFixed(1) + ' ' + (paso * 0.5).toFixed(1) },
          (paso * 0.25).toFixed(2) + 'px',
          apaga
        );
      });
    }

    if (tr.kGrosor > 1.02) {
      var iFin = 0;
      while (iFin < anchoIzq.length - 1 && anchoIzq[iFin] > hebraW * 1.01) iFin++;
      pintaPerspectiva(0, iFin);
      pintaPerspectiva(circuito.length - 1 - iFin, circuito.length - 1);
    }

    /* Línea de agarre (invisible) para arrastrar el cabo. Va sobre el EJE, no
       sobre las dos hebras: así el blanco no se ensancha al separarlas. Y se
       topa con el canalón libre, para que en una ventana estrecha no llegue a
       robarle el clic a ninguna tarjeta o enlace de la columna de contenido
       (medido: a 390px sin este tope el blanco se metía 1px en la tarjeta de
       modelo). El cálculo sirve igual para los dos costados: el contenedor está
       centrado, así que el canalón derecho mide lo mismo que el izquierdo. */
    // En colgante no hay canalón que respetar (el cabo baja por el centro, en un
    // tramo donde no hay contenido), así que el agarre mide lo que el propio par.
    var tope = g.colgante
      ? 2 * tr.sep0 + hebraW + 8
      : Math.min(2 * (g.canal - g.xIzq) - 4, 2 * g.xIzq - 2);
    add(
      'rr-cabo__agarre',
      dEje,
      Math.max(14, Math.min(Math.max(24, 2 * tr.sep0 + hebraW + 8), tope))
    );

    // Herraje, según el papel declarado por cada sección.
    anclas.forEach(function (a) {
      if (a.papel === 'arranque') {
        var maquina = pintaMaquina(tr, a.img);
        if (maquina) {
          /* ORDEN DE PINTADO (20/08/2026, ronda 3). La FOTO se inserta la
             PRIMERA, o sea DETRAS de todo el cabo. Hasta la ronda 2 iba la
             ultima, por delante, para tapar el arranque del trazo; el criterio
             ha cambiado (ver pintaBoca): la cuerda va por encima de la maquina y
             la credibilidad la da la boca, no esconderla. */
          if (g.colgante) {
            /* COLGANTE (movil): INTACTO. Ahi la cuerda sale por la boca de abajo
               del tambor, donde el filo de la foto es casi horizontal y el cabo
               pasa por detras de forma natural, asi que la foto se sigue
               pintando la ULTIMA (por delante) y es ella la que tapa el remate.
               El criterio de "cuerda por delante + boca" es de la salida por el
               FLANCO, que es una pieza de escritorio. */
            capas.appendChild(maquina);
          } else {
            capas.insertBefore(maquina, capas.firstChild);
            /* Las dos aberturas se leen del CIRCUITO ya montado, no de una
               formula: circuito[0] es el arranque de la hebra de abajo y el
               ultimo punto el de la de arriba (ver lazo()). Asi la boca queda
               siempre exactamente sobre el remate del trazo, aunque cambie el
               angulo de salida con el ancho de ventana. */
            var boca = pintaBoca(tr, hebraW, bocasDelCircuito(circuito));
            if (boca) {
              // La sombra de contacto va entre la foto y el cabo.
              capas.insertBefore(boca.contacto, maquina.nextSibling);
              // La boca, encima de todo: se come el remate de las dos hebras.
              capas.appendChild(boca.tapa);
            }
          }
        }
      }
      // El collarín vive en un tramo de la tirada larga; en colgante no hay
      // tirada donde ponerlo.
      if (a.papel === 'ojal' && !g.colgante) {
        var t = null;
        g.tramos.forEach(function (x) {
          if (x.ancla === a) t = x;
        });
        if (t) {
          var frac = a.ojal === 'alto' ? 0.24 : a.ojal === 'bajo' ? 0.76 : 0.5;
          capas.appendChild(
            pintaCollarin(g, tr, pts, t.arriba - g.arriba + (t.abajo - t.arriba) * frac)
          );
        }
      }
    });

    while (svgEl.firstChild) svgEl.removeChild(svgEl.firstChild);
    svgEl.appendChild(capas);
    if (medidor && medidor.parentNode) medidor.parentNode.removeChild(medidor);

    /* Velocidad de la trenza. El ciclo de la animación mide UN paso de trenzado,
       así que los px de scroll por ciclo salen del paso real y de la velocidad
       lineal que se quiere (ver VELOCIDAD_TRENZA). Antes era un número fijo (45)
       porque el paso también lo era (22px). */
    scrollPorCiclo = Math.max(4, lay / VELOCIDAD_TRENZA);
    var recorrido = Math.max(
      1,
      document.documentElement.scrollHeight - document.documentElement.clientHeight
    );
    document.documentElement.style.setProperty(
      '--rr-cabo-ciclos',
      String(Math.max(1, Math.round(recorrido / scrollPorCiclo)))
    );

    host.classList.add('is-listo');
    actualizaCorriendo();
  }

  /* Sólo corren los trozos que caen cerca de la ventana (ver TROZO en
     pintaTrenza). El margen es una ventana entera por arriba y otra por abajo:
     así ningún trozo cambia de estado estando a la vista, que es lo único que se
     notaría (al activarse, un trozo salta al patrón animado). */
  function actualizaCorriendo() {
    if (reduce || !trozos.length) return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var vh = window.innerHeight || 800;
    var a = y - arribaLienzo - vh;
    var b = y - arribaLienzo + vh * 2;
    for (var i = 0; i < trozos.length; i++) {
      var t = trozos[i];
      var dentro = t.y1 >= a && t.y0 <= b;
      if (dentro !== t.on) {
        t.on = dentro;
        if (dentro) t.el.classList.add('is-corriendo');
        else t.el.classList.remove('is-corriendo');
      }
    }
  }

  /* -------------------------------------------------------------- movimiento */

  function movimientoPorScroll(escribePull) {
    var raiz = document.documentElement;
    var pedido = false;

    function pinta() {
      pedido = false;
      var y = window.pageYOffset || raiz.scrollTop || 0;
      if (escribePull) raiz.style.setProperty('--rr-cabo-pull', ((y / scrollPorCiclo) % 1).toFixed(4));
      actualizaCorriendo();
    }

    window.addEventListener(
      'scroll',
      function () {
        if (pedido) return;
        pedido = true;
        window.requestAnimationFrame(pinta);
      },
      { passive: true }
    );
    pinta();
  }

  /* ---------------------------------------------------------------- arrastre */

  // Tirar del cabo hacia abajo baja por la página, igual que tirar de la cuerda
  // de la máquina la hace avanzar. Es una vía ADICIONAL: no se toca la rueda, ni
  // el trackpad, ni el teclado, ni el swipe (no hay ningún listener de esos).
  function arrastre() {
    var TIRO = 1.5;
    var tirando = false;
    var ultimaY = 0;
    var puntero = null;

    document.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        var t = e.target;
        if (!t || !t.classList || !t.classList.contains('rr-cabo__agarre')) return;
        tirando = true;
        ultimaY = e.clientY;
        puntero = e.pointerId;
        document.documentElement.classList.add('rr-cabo-tirando');
        try {
          t.setPointerCapture(e.pointerId);
        } catch (err) {
          /* sin captura seguimos: el listener está en document */
        }
        e.preventDefault(); // evita la selección de texto y el arrastre nativo
      },
      { passive: false }
    );

    document.addEventListener('pointermove', function (e) {
      if (!tirando || e.pointerId !== puntero) return;
      var dy = e.clientY - ultimaY;
      ultimaY = e.clientY;
      if (dy) window.scrollBy(0, dy * TIRO);
    });

    function suelta(e) {
      if (!tirando || (e && e.pointerId !== puntero)) return;
      tirando = false;
      puntero = null;
      document.documentElement.classList.remove('rr-cabo-tirando');
    }
    document.addEventListener('pointerup', suelta);
    document.addEventListener('pointercancel', suelta);
    window.addEventListener('blur', function () {
      suelta(null);
    });
  }

  /* ------------------------------------------------------------------ arranque */

  function arranca() {
    anclas = Array.prototype.map.call(document.querySelectorAll('.rr-cabo'), function (el) {
      return {
        el: el,
        papel: el.getAttribute('data-rr-cabo') || 'recto',
        ojal: el.getAttribute('data-rr-cabo-ojal') || 'medio',
        // URL del recorte de la máquina; la pone el snippet, porque un asset de
        // Shopify lleva su propio ?v= y no se puede construir desde el cliente.
        img: el.getAttribute('data-rr-cabo-img') || ''
      };
    });
    if (!anclas.length) return;

    reduce = !!(
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );

    var scrollTimeline =
      !reduce && window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()');
    if (scrollTimeline) {
      document.documentElement.classList.add('rr-cabo-scrolltimeline');
    }

    construye();
    /* El vigilante de scroll se registra SIEMPRE que haya movimiento, aunque la
       animación la lleve el CSS: hace falta para activar y desactivar los trozos
       del trenzado según lo que se ve. Sólo escribe --rr-cabo-pull cuando no hay
       ruta de scroll-driven animations. */
    if (!reduce) movimientoPorScroll(!scrollTimeline);
    arrastre();

    // Rehacer el trazado cuando la página cambia de forma: al medir de verdad,
    // el recorrido nunca se descuadra respecto de las secciones reales.
    var espera = 0;
    function rehaz() {
      window.clearTimeout(espera);
      espera = window.setTimeout(construye, 150);
    }
    window.addEventListener('resize', rehaz);
    window.addEventListener('orientationchange', rehaz);
    window.addEventListener('load', rehaz);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(rehaz);
      ro.observe(document.body);
    }
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(rehaz).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();
